var _rect, _rect2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 587,
    viewBox: "0 0 752 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_1511_19003)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 752,
    height: 587,
    fill: "#FFFBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -17.2383,
    width: 1299.12,
    height: 587,
    fill: "#FFFBEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1511_19003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -18,
    y: 0,
    width: 1300,
    height: 587
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-17.2383 0H1281.88V587H-17.2383V0Z",
    fill: "#FFFFE8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1511_19003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0313 172.867L95.4634 164.343C94.5974 159.636 98.2568 155.017 103.637 154.027C109.017 153.038 114.08 156.052 114.946 160.759L116.514 169.283",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.398 167.823L96.3094 168.943L97.7032 176.52L103.792 175.4L102.398 167.823Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.704,
    y: 166.479,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(-10.4233 109.704 166.479)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.29 168.065L117.508 167.841L118.105 171.088L116.888 171.312",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8071 171.649L95.5895 171.873L96.1868 175.12L97.4045 174.896",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.285 172.866L573.717 164.342C572.851 159.634 576.511 155.016 581.891 154.026C587.271 153.036 592.334 156.05 593.2 160.758L594.768 169.282",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.651 167.822L574.563 168.942L575.956 176.519L582.045 175.399L580.651 167.822Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.958,
    y: 166.478,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(-10.4233 587.958 166.478)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.544 168.064L595.762 167.84L596.359 171.087L595.141 171.311",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.061 171.648L573.843 171.872L574.441 175.119L575.658 174.895",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.0498 27.5925L-8.94006 20.5923C-6.11803 16.7261 -0.248487 16.2066 4.16993 19.4317C8.58835 22.6569 9.88247 28.4056 7.06044 32.2717L1.9507 39.2719",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.696777,
    y: 32.3997,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(36.1272 -0.696777 32.3997)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68091 38.2716L3.68094 39.0016L1.73437 41.6683L0.73434 40.9384",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0577 315.525L33.4897 307.002C32.6238 302.294 36.2831 297.675 41.6632 296.686C47.0432 295.696 52.1066 298.71 52.9725 303.418L54.5405 311.941",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4237 310.482L34.3353 311.602L35.7291 319.178L41.8175 318.058L40.4237 310.482Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7305,
    y: 309.138,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(-10.4233 47.7305 309.138)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3162 310.723L55.5338 310.499L56.1312 313.747L54.9135 313.971",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8335 314.307L33.6158 314.531L34.2131 317.779L35.4308 317.555",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.311 315.523L511.743 306.999C510.877 302.292 514.537 297.673 519.917 296.683C525.297 295.694 530.36 298.708 531.226 303.415L532.794 311.939",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.677 310.48L512.589 311.6L513.983 319.176L520.071 318.056L518.677 310.48Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.984,
    y: 309.136,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(-10.4233 525.984 309.136)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.57 310.721L533.787 310.497L534.385 313.745L533.167 313.969",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.087 314.305L511.869 314.529L512.467 317.776L513.684 317.552",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.485 385.102L194.817 378.269C197.761 374.496 203.645 374.165 207.957 377.53C212.27 380.895 213.379 386.682 210.434 390.456L205.103 397.289",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82 385.765L191.939 381.957L187.2 388.03L192.081 391.839L196.82 385.765Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.676,
    y: 390.335,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(37.9653 202.676 390.335)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.865 396.313L206.841 397.074L204.81 399.677L203.834 398.916",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.246 384.126L189.27 383.364L187.239 385.967L188.215 386.729",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.737 385.1L673.069 378.268C676.014 374.494 681.897 374.163 686.21 377.528C690.522 380.893 691.631 386.681 688.687 390.454L683.355 397.287",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.072 385.763L670.192 381.955L665.452 388.029L670.333 391.837L675.072 385.763Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.929,
    y: 390.334,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(37.9653 680.929 390.334)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.116 396.311L685.093 397.073L683.061 399.676L682.085 398.914",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.499 384.124L667.523 383.362L665.491 385.965L666.468 386.727",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5049 414.938L69.8452 406.278C70.0331 401.495 74.6166 397.792 80.0826 398.007C85.5487 398.221 89.8275 402.273 89.6396 407.055L89.2994 415.716",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.847 411.195L69.6613 410.952L69.3588 418.649L75.5446 418.892L75.847 411.195Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2703,
    y: 411.486,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(2.25 83.2703 411.486)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.348 414.479L90.5852 414.527L90.4556 417.826L89.2184 417.778",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5535 413.701L68.3163 413.652L68.1867 416.951L69.4238 417",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.758 414.937L548.099 406.277C548.287 401.494 552.87 397.791 558.336 398.005C563.802 398.22 568.081 402.271 567.893 407.054L567.553 415.714",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.101 411.193L547.915 410.95L547.613 418.648L553.798 418.891L554.101 411.193Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.524,
    y: 411.485,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(2.25 561.524 411.485)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.601 414.477L568.839 414.526L568.709 417.825L567.472 417.776",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.807 413.699L546.57 413.651L546.44 416.95L547.677 416.998",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 490.348L34.4307 491.139C39.1972 491.576 42.6565 496.346 42.1572 501.793C41.6578 507.241 37.389 511.303 32.6225 510.866L23.9919 510.075",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.053 490.347L512.683 491.138C517.45 491.575 520.909 496.345 520.41 501.793C519.91 507.24 515.642 511.302 510.875 510.865L502.244 510.074",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2083 496.877L29.7733 490.712L22.1017 490.009L21.5366 496.173L29.2083 496.877Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.461 496.876L508.026 490.712L500.354 490.008L499.789 496.173L507.461 496.876Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5302,
    y: 504.275,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(95.2373 28.5302 504.275)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.782,
    y: 504.274,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(95.2373 506.782 504.274)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2255 510.188L25.1124 511.421L21.8246 511.12L21.9376 509.887",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0332 490.461L27.1462 489.228L23.8584 488.927L23.7454 490.16",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.286 490.46L505.399 489.228L502.111 488.926L501.998 490.159",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.549 527.759L222.88 520.927C225.825 517.153 231.708 516.822 236.021 520.187C240.333 523.553 241.443 529.34 238.498 533.113L233.166 539.946",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.141 532.845L703.472 526.012C706.417 522.238 712.3 521.907 716.613 525.273C720.926 528.638 722.035 534.425 719.09 538.199L713.758 545.031",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.883 528.422L220.003 524.614L215.264 530.687L220.144 534.496L224.883 528.422Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.476 533.508L700.595 529.7L695.856 535.773L700.736 539.582L705.476 533.508Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.739,
    y: 532.992,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(37.9653 230.739 532.992)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 711.332,
    y: 538.078,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(37.9653 711.332 538.078)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.928 538.969L234.904 539.731L232.873 542.334L231.897 541.572",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.52 544.055L715.496 544.817L713.465 547.42L712.489 546.658",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31 526.783L217.334 526.021L215.303 528.624L216.279 529.386",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35 514.948L411.573 506.316C411.144 501.548 415.213 497.286 420.661 496.796C426.109 496.306 430.874 499.773 431.303 504.54L432.08 513.172",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.158 510.419L411.992 510.974L412.682 518.647L418.848 518.092L418.158 510.419Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.557,
    y: 509.753,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(-5.1419 425.557 509.753)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.969 511.938L433.202 511.828L433.498 515.116L432.265 515.227",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.238 513.714L411.005 513.825L411.301 517.113L412.534 517.002",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.754 210.487L434.977 213.224C439.518 214.736 441.799 220.17 440.071 225.36C438.343 230.55 433.261 233.532 428.72 232.02L420.497 229.282",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.583 217.621L430.539 211.747L423.229 209.314L421.274 215.187L428.583 217.621Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.237,
    y: 224.669,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(108.413 426.237 224.669)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.671 229.673L421.28 230.848L418.147 229.805L418.538 228.631",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.929 210.878L428.32 209.703L425.187 208.66L424.796 209.835",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.857 39.0558L439.136 32.1825C442.052 28.3866 447.932 28.0106 452.27 31.3429C456.609 34.6751 457.762 40.4536 454.846 44.2496L449.567 51.1228",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.196 39.663L436.287 35.892L431.594 42.0015L436.503 45.7725L441.196 39.663Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.088,
    y: 44.1881,
    width: 6.19053,
    height: 7.70378,
    transform: "rotate(37.528 447.088 44.1881)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.321 50.1409L451.303 50.8951L449.292 53.5134L448.31 52.7592",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.611 38.0739L433.629 37.3197L431.618 39.938L432.6 40.6922",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.427 49.4724L126.913 43.4676C129.39 40.1512 134.471 39.7581 138.261 42.5895C142.052 45.421 143.116 50.4047 140.638 53.7211L136.152 59.7259",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.782 49.9124L124.493 46.7081L120.505 52.0457L124.794 55.25L128.782 49.9124Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.928,
    y: 53.7577,
    width: 5.35387,
    height: 6.66259,
    transform: "rotate(36.7617 133.928 53.7577)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.793 58.8685L137.651 59.5094L135.942 61.7969L135.085 61.1561",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.068 48.615L122.21 47.9741L120.501 50.2617L121.359 50.9025",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.68 49.4709L605.166 43.4661C607.643 40.1498 612.724 39.7566 616.514 42.5881C620.304 45.4195 621.368 50.4033 618.891 53.7196L614.405 59.7245",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.034 49.9108L602.745 46.7065L598.758 52.0442L603.047 55.2484L607.034 49.9108Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.181,
    y: 53.7561,
    width: 5.35387,
    height: 6.66259,
    transform: "rotate(36.7617 612.181 53.7561)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.046 58.8669L615.904 59.5078L614.195 61.7953L613.337 61.1545",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.321 48.6134L600.463 47.9726L598.754 50.2601L599.612 50.901",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6765 189.143L90.0421 194.924L82.3336 191.412L84.968 185.63L92.6765 189.143Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.969,
    y: 195.803,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(114.498 91.969 195.803)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0421 194.924L92.6765 189.143L84.968 185.63L82.3336 191.412",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.0168,
    y: 188.436,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(24.4976 86.0168 188.436)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9073,
    y: 189.753,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(24.4976 88.9073 189.753)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4551 199.206L88.0178 204.475",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.93 189.142L568.296 194.923L560.587 191.411L563.222 185.629L570.93 189.142Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.223,
    y: 195.801,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(114.498 570.223 195.801)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.296 194.923L570.93 189.142L563.222 185.629L560.587 191.411",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.271,
    y: 188.435,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(24.4976 564.271 188.435)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.161,
    y: 189.751,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(24.4976 567.161 189.751)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.709 199.204L566.271 204.473",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.964 292.084L289.729 297.803L282.103 301.491L279.337 295.772L286.964 292.084Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.636,
    y: 296.881,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(64.193 291.636 296.881)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.729 297.803L286.964 292.084L279.337 295.772L282.103 301.491",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.166,
    y: 296.756,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-25.807 282.166 296.756)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.025,
    y: 295.373,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-25.807 285.025 295.373)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.346 310.992L295.785 305.46",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.092 327.762L167.794 323.49L173.491 329.76L168.788 334.032L163.092 327.762Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.37,
    y: 321.923,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 166.37 321.923)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.794 323.49L163.092 327.762L168.788 334.032L173.491 329.76",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.932,
    y: 331.041,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 168.932 331.041)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.796,
    y: 328.69,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 166.796 328.69)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.968 324.92L173.424 315.515",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.345 327.761L646.047 323.488L651.744 329.758L647.041 334.031L641.345 327.761Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.623,
    y: 321.921,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 644.623 321.921)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.047 323.488L641.345 327.761L647.041 334.031L651.744 329.758",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.185,
    y: 331.039,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 647.185 331.039)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.049,
    y: 328.689,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 645.049 328.689)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.221 324.918L651.677 315.513",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.389 486.79L225.091 482.518L230.787 488.788L226.085 493.06L220.389 486.79Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.667,
    y: 480.951,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 223.667 480.951)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.091 482.518L220.389 486.79L226.085 493.06L230.787 488.788",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.229,
    y: 490.069,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 226.229 490.069)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.093,
    y: 487.718,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 224.093 487.718)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.265 483.948L230.721 474.543",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.642 486.789L703.344 482.516L709.04 488.786L704.338 493.059L698.642 486.789Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.92,
    y: 480.949,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 701.92 480.949)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.344 482.516L698.642 486.789L704.338 493.059L709.04 488.786",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704.481,
    y: 490.067,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 704.481 490.067)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.345,
    y: 487.716,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 702.345 487.716)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.518 483.946L708.974 474.541",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.061 533.563L374.763 529.291L380.46 535.561L375.757 539.833L370.061 533.563Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.339,
    y: 527.724,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 373.339 527.724)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.763 529.291L370.061 533.563L375.757 539.833L380.46 535.561",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.901,
    y: 536.842,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 375.901 536.842)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.765,
    y: 534.491,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 373.765 534.491)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.938 530.72L380.393 521.316",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.917 578.114L227.598 571.797L236.02 572.704L235.34 579.021L226.917 578.114Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.492,
    y: 571.57,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-83.8519 225.492 571.57)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.598 571.797L226.917 578.114L235.34 579.021L236.02 572.704",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.461,
    y: 576.688,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-173.852 233.461 576.688)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.303,
    y: 576.348,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-173.852 230.303 576.348)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.146 563.456L226.513 562.095",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.509 583.199L708.189 576.882L716.612 577.789L715.931 584.106L707.509 583.199Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.084,
    y: 576.655,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-83.8519 706.084 576.655)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.189 576.882L707.509 583.199L715.931 584.106L716.612 577.789",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 714.052,
    y: 581.774,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-173.852 714.052 581.774)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710.895,
    y: 581.434,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-173.852 710.895 581.434)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.738 568.541L707.104 567.18",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.231 584.532L128.474 578.588L136.4 581.579L134.157 587.523L126.231 584.532Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.493,
    y: 577.84,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-69.3232 126.493 577.84)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.474 578.588L126.231 584.532L134.157 587.523L136.4 581.579",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.923,
    y: 584.794,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-159.323 132.923 584.794)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.952,
    y: 583.673,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-159.323 129.952 583.673)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.746 573.411L129.858 568.924",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.823 589.617L609.066 583.673L616.992 586.664L614.748 592.608L606.823 589.617Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.085,
    y: 582.926,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-69.3232 607.085 582.926)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.066 583.673L606.823 589.617L614.748 592.608L616.992 586.664",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.338 578.497L610.449 574.01",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06396 464.573L8.76642 460.301L14.4626 466.571L9.76019 470.843L4.06396 464.573Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.34229,
    y: 458.734,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 7.34229 458.734)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76642 460.301L4.06396 464.573L9.76019 470.843L14.4626 466.571",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.90332,
    y: 467.852,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 9.90332 467.852)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.76782,
    y: 465.501,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 7.76782 465.501)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9399 461.73L14.3956 452.326",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.317 464.572L487.02 460.299L492.716 466.569L488.014 470.841L482.317 464.572Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.596,
    y: 458.732,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 485.596 458.732)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.02 460.299L482.317 464.572L488.014 470.841L492.716 466.569",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.157,
    y: 467.85,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 488.157 467.85)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.021,
    y: 465.499,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 486.021 465.499)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.194 461.729L492.65 452.324",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.287 387.398L106.99 383.125L112.686 389.395L107.983 393.668L102.287 387.398Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.566,
    y: 381.558,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 105.566 381.558)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.99 383.125L102.287 387.398L107.983 393.668L112.686 389.395",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.127,
    y: 390.676,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 108.127 390.676)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.991,
    y: 388.325,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 105.991 388.325)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.164 384.555L112.619 375.15",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.54 387.396L585.243 383.124L590.939 389.394L586.236 393.666L580.54 387.396Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.818,
    y: 381.557,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-42.2551 583.818 381.557)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.243 383.124L580.54 387.396L586.236 393.666L590.939 389.394",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.38,
    y: 390.675,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 586.38 390.675)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.244,
    y: 388.324,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-132.255 584.244 388.324)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.417 384.553L590.872 375.148",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.341 300.365L398.611 294.431L406.523 297.458L404.253 303.392L396.341 300.365Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.633,
    y: 293.675,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(-69.0664 396.633 293.675)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.611 294.431L396.341 300.365L404.253 303.392L406.523 297.458",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.032,
    y: 300.657,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-159.066 403.032 300.657)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.065,
    y: 299.522,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-159.066 400.065 299.522)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.906 289.314L400.038 284.774",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.811 112.622L267.915 118.879L259.573 120.352L258.469 114.095L266.811 112.622Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.001,
    y: 118.511,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(79.9863 270.001 118.511)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.915 118.879L266.811 112.622L258.469 114.095L259.573 120.352",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.922,
    y: 115.813,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-10.0137 260.922 115.813)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.05,
    y: 115.26,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-10.0137 264.05 115.26)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.145 130.105L271.658 127.895",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.063 112.621L746.168 118.878L737.826 120.351L736.721 114.094L745.063 112.621Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.254,
    y: 118.509,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(79.9863 748.254 118.509)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.168 118.878L745.063 112.621L736.721 114.094L737.826 120.351",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.175,
    y: 115.811,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-10.0137 739.175 115.811)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.303,
    y: 115.259,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-10.0137 742.303 115.259)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.398 130.103L749.911 127.894",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.48242,
    y: 65.597,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(48.9745 -3.48242 65.597)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.8125 81.1268L2.77358 72.7863",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.002 62.1929L473.173 66.9859L466.782 72.5463L462.612 67.7532L469.002 62.1929Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.77,
    y: 65.5958,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(48.9745 474.77 65.5958)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.173 66.9859L469.002 62.1929L462.612 67.7532L466.782 72.5463",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.599,
    y: 67.9607,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-41.0255 465.599 67.9607)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.996,
    y: 65.8756,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-41.0255 467.996 65.8756)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.44 81.1252L481.026 72.7847",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.619 44.7053L224.434 51.0062L216.033 52.092L215.218 45.7911L223.619 44.7053Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.534,
    y: 50.7345,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(82.6359 226.534 50.7345)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.434 51.0062L223.619 44.7053L215.218 45.7911L216.033 52.092",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.59,
    y: 47.6196,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-7.36415 217.59 47.6196)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.74,
    y: 47.2125,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-7.36415 220.74 47.2125)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.154 61.8142L227.756 60.1855",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.873 44.7037L702.687 51.0046L694.286 52.0904L693.472 45.7895L701.873 44.7037Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704.788,
    y: 50.7329,
    width: 12.7066,
    height: 12.7066,
    transform: "rotate(82.6359 704.788 50.7329)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.687 51.0046L701.873 44.7037L693.472 45.7895L694.286 52.0904",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.843,
    y: 47.618,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-7.36415 695.843 47.618)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 698.993,
    y: 47.2109,
    width: 1.05888,
    height: 1.05888,
    transform: "rotate(-7.36415 698.993 47.2109)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.407 61.8126L706.009 60.184",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.167 197.615H142.012C143.367 197.615 144.498 196.6 144.62 195.274L145.765 182.768C143.787 182.632 140.635 182.446 138.281 182.446C135.927 182.446 132.775 182.632 130.797 182.768L131.555 195.197C131.639 196.555 132.782 197.615 134.167 197.615Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.797 182.768L131.555 195.197C131.639 196.555 132.782 197.615 134.167 197.615H142.012C143.367 197.615 144.498 196.6 144.62 195.274L145.765 182.768M130.797 182.768C129.671 182.845 128.926 182.905 128.926 182.905M130.797 182.768C132.775 182.632 135.927 182.446 138.281 182.446C140.635 182.446 143.787 182.632 145.765 182.768M145.765 182.768C146.89 182.845 147.635 182.905 147.635 182.905",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.475 181.94V178.906H141.088V181.94",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54 181.94L136.411 181.94",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.152 181.94H142.023",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.281 186.996V193.064",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54 188.008L134.54 192.053",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.023 188.008L142.023 192.053",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.421 197.614H620.266C621.62 197.614 622.751 196.598 622.874 195.272L624.018 182.766C622.04 182.631 618.888 182.444 616.534 182.444C614.18 182.444 611.028 182.631 609.051 182.766L609.809 195.195C609.892 196.554 611.036 197.614 612.421 197.614Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.051 182.766L609.809 195.195C609.892 196.554 611.036 197.614 612.421 197.614H620.266C621.62 197.614 622.751 196.598 622.874 195.272L624.018 182.766M609.051 182.766C607.925 182.843 607.18 182.904 607.18 182.904M609.051 182.766C611.028 182.631 614.18 182.444 616.534 182.444C618.888 182.444 622.04 182.631 624.018 182.766M624.018 182.766C625.144 182.843 625.889 182.904 625.889 182.904",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.728 181.938V178.905H619.341V181.938",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.793 181.939L614.664 181.939",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.406 181.939H620.276",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.534 186.995V193.063",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.793 188.006L612.793 192.051",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.276 188.006L620.276 192.051",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.48959 508.655H-0.644421C0.71028 508.655 1.84102 507.64 1.96367 506.314L3.10778 493.808C1.13031 493.672 -2.02201 493.486 -4.37589 493.486C-6.72976 493.486 -9.88208 493.672 -11.8596 493.808L-11.1016 506.237C-11.0178 507.595 -9.87465 508.655 -8.48959 508.655Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.8596 493.808L-11.1016 506.237C-11.0178 507.595 -9.87465 508.655 -8.48959 508.655H-0.644421C0.710281 508.655 1.84102 507.64 1.96367 506.314L3.10778 493.808M-11.8596 493.808C-12.9854 493.885 -13.7305 493.945 -13.7305 493.945M-11.8596 493.808C-9.88208 493.672 -6.72976 493.486 -4.37589 493.486C-2.02201 493.486 1.13031 493.672 3.10778 493.808M3.10778 493.808C4.23366 493.885 4.97869 493.945 4.97869 493.945",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.50464 492.98H-0.633722",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.634521 499.048L-0.634521 503.093",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.764 508.653H477.609C478.964 508.653 480.094 507.638 480.217 506.312L481.361 493.806C479.384 493.671 476.231 493.484 473.878 493.484C471.524 493.484 468.371 493.671 466.394 493.806L467.152 506.235C467.236 507.594 468.379 508.653 469.764 508.653Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.394 493.806L467.152 506.235C467.236 507.594 468.379 508.653 469.764 508.653H477.609C478.964 508.653 480.094 507.638 480.217 506.312L481.361 493.806M466.394 493.806C465.268 493.883 464.523 493.944 464.523 493.944M466.394 493.806C468.371 493.671 471.524 493.484 473.878 493.484C476.231 493.484 479.384 493.671 481.361 493.806M481.361 493.806C482.487 493.883 483.232 493.944 483.232 493.944",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.071 492.978V489.945H476.684V492.978",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.135 492.979L472.006 492.979",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.749 492.979H477.62",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.878 498.035V504.103",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.135 499.046L470.135 503.091",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.619 499.046L477.619 503.091",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.625 160.859L408.994 163.551C410.266 164.016 411.677 163.45 412.247 162.247L417.613 150.893C415.802 150.087 412.905 148.83 410.694 148.022C408.484 147.214 405.459 146.308 403.555 145.756L400.002 157.691C399.614 158.996 400.324 160.383 401.625 160.859Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.555 145.756L400.002 157.691C399.614 158.996 400.324 160.383 401.625 160.859L408.994 163.551C410.266 164.016 411.677 163.45 412.247 162.247L417.613 150.893M403.555 145.756C402.471 145.442 401.75 145.244 401.75 145.244M403.555 145.756C405.459 146.308 408.484 147.214 410.694 148.022C412.905 148.83 415.802 150.087 417.613 150.893M417.613 150.893C418.644 151.351 419.323 151.664 419.323 151.664",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.231 146.584L409.272 143.734L414.544 145.66L413.503 148.51",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.353 146.263L409.11 146.905",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.625 148.189L414.382 148.831",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.132 152.297L407.05 157.996",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.271 151.962L403.883 155.762",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3 154.531L410.912 158.33",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.761 91.2067H256.606C257.961 91.2067 259.092 90.1915 259.214 88.8655L260.358 76.3592C258.381 76.2238 255.228 76.0371 252.875 76.0371C250.521 76.0371 247.368 76.2238 245.391 76.3592L246.149 88.7882C246.233 90.1469 247.376 91.2067 248.761 91.2067Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.391 76.3592L246.149 88.7882C246.233 90.1469 247.376 91.2067 248.761 91.2067H256.606C257.961 91.2067 259.092 90.1915 259.214 88.8655L260.358 76.3592M245.391 76.3592C244.265 76.4363 243.52 76.4968 243.52 76.4968M245.391 76.3592C247.368 76.2238 250.521 76.0371 252.875 76.0371C255.228 76.0371 258.381 76.2238 260.358 76.3592M260.358 76.3592C261.484 76.4363 262.229 76.4968 262.229 76.4968",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.068 75.5314V72.4974H255.681V75.5314",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.133 75.5315L251.004 75.5315",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.746 75.5315H256.617",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.875 80.5879V86.6557",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.133 81.5991L249.133 85.6443",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.616 81.5991L256.616 85.6443",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.014 91.2051H734.859C736.214 91.2051 737.345 90.1899 737.468 88.8639L738.612 76.3576C736.634 76.2222 733.482 76.0355 731.128 76.0355C728.774 76.0355 725.622 76.2222 723.644 76.3576L724.402 88.7866C724.486 90.1453 725.629 91.2051 727.014 91.2051Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.644 76.3576L724.402 88.7866C724.486 90.1453 725.629 91.2051 727.014 91.2051H734.859C736.214 91.2051 737.345 90.1899 737.468 88.8639L738.612 76.3576M723.644 76.3576C722.518 76.4347 721.773 76.4952 721.773 76.4952M723.644 76.3576C725.622 76.2222 728.774 76.0355 731.128 76.0355C733.482 76.0355 736.634 76.2222 738.612 76.3576M738.612 76.3576C739.738 76.4347 740.483 76.4952 740.483 76.4952",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.322 75.5296V72.4957H733.934V75.5296",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.386 75.5298L729.257 75.5298",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.999 75.5298H734.87",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.128 80.5862V86.654",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.386 81.5975L727.386 85.6428",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.869 81.5975L734.869 85.6428",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.174 28.063H218.019C219.374 28.063 220.504 27.0478 220.627 25.7219L221.771 13.2155C219.794 13.0801 216.641 12.8934 214.288 12.8934C211.934 12.8934 208.781 13.0801 206.804 13.2155L207.562 25.6445C207.646 27.0033 208.789 28.063 210.174 28.063Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.804 13.2155L207.562 25.6445C207.646 27.0033 208.789 28.063 210.174 28.063H218.019C219.374 28.063 220.504 27.0478 220.627 25.7219L221.771 13.2155M206.804 13.2155C205.678 13.2926 204.933 13.3531 204.933 13.3531M206.804 13.2155C208.781 13.0801 211.934 12.8934 214.288 12.8934C216.641 12.8934 219.794 13.0801 221.771 13.2155M221.771 13.2155C222.897 13.2926 223.642 13.3531 223.642 13.3531",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.481 12.3876V9.35364H217.094V12.3876",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.546 12.3877L212.417 12.3877",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.158 12.3877H218.029",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.288 17.4441V23.5119",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.546 18.4554L210.546 22.5007",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.029 18.4554L218.029 22.5007",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.426 28.0614H696.271C697.626 28.0614 698.757 27.0462 698.879 25.7203L700.024 13.2139C698.046 13.0785 694.894 12.8918 692.54 12.8918C690.186 12.8918 687.034 13.0785 685.056 13.2139L685.814 25.6429C685.898 27.0017 687.041 28.0614 688.426 28.0614Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.056 13.2139L685.814 25.6429C685.898 27.0017 687.041 28.0614 688.426 28.0614H696.271C697.626 28.0614 698.757 27.0462 698.879 25.7203L700.024 13.2139M685.056 13.2139C683.93 13.291 683.185 13.3515 683.185 13.3515M685.056 13.2139C687.034 13.0785 690.186 12.8918 692.54 12.8918C694.894 12.8918 698.046 13.0785 700.024 13.2139M700.024 13.2139C701.149 13.291 701.894 13.3515 701.894 13.3515",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.734 12.3863V9.35242H695.346V12.3863",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.798 12.3865L690.669 12.3865",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.411 12.3865H696.282",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.539 17.4429V23.5107",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.798 18.4539L688.798 22.4991",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.281 18.4539L696.281 22.4991",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.295 258.42H198.14C199.495 258.42 200.626 257.405 200.748 256.079L201.892 243.573C199.915 243.437 196.763 243.25 194.409 243.25C192.055 243.25 188.903 243.437 186.925 243.573L187.683 256.002C187.767 257.36 188.91 258.42 190.295 258.42Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.925 243.573L187.683 256.002C187.767 257.36 188.91 258.42 190.295 258.42H198.14C199.495 258.42 200.626 257.405 200.748 256.079L201.892 243.573M186.925 243.573C185.799 243.65 185.054 243.71 185.054 243.71M186.925 243.573C188.903 243.437 192.055 243.25 194.409 243.25C196.763 243.25 199.915 243.437 201.892 243.573M201.892 243.573C203.018 243.65 203.763 243.71 203.763 243.71",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.602 242.745V239.711H197.215V242.745",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.667 242.745L192.538 242.745",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28 242.745H198.151",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.409 247.802V253.869",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.667 248.812L190.667 252.858",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15 248.812L198.15 252.858",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.548 258.418H676.393C677.748 258.418 678.879 257.403 679.002 256.077L680.146 243.571C678.168 243.436 675.016 243.249 672.662 243.249C670.308 243.249 667.156 243.436 665.178 243.571L665.936 256C666.02 257.359 667.163 258.418 668.548 258.418Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.178 243.571L665.936 256C666.02 257.359 667.163 258.418 668.548 258.418H676.393C677.748 258.418 678.879 257.403 679.002 256.077L680.146 243.571M665.178 243.571C664.052 243.648 663.307 243.709 663.307 243.709M665.178 243.571C667.156 243.436 670.308 243.249 672.662 243.249C675.016 243.249 678.168 243.436 680.146 243.571M680.146 243.571C681.271 243.648 682.017 243.709 682.017 243.709",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.856 242.743V239.709H675.468V242.743",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.92 242.743L670.791 242.743",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.533 242.743H676.404",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.662 247.8V253.868",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.92 248.811L668.92 252.856",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.403 248.811L676.403 252.856",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.688 198.785H297.533C298.888 198.785 300.019 197.77 300.141 196.444L301.285 183.937C299.308 183.802 296.155 183.615 293.802 183.615C291.448 183.615 288.295 183.802 286.318 183.937L287.076 196.366C287.16 197.725 288.303 198.785 289.688 198.785Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.318 183.937L287.076 196.366C287.16 197.725 288.303 198.785 289.688 198.785H297.533C298.888 198.785 300.019 197.77 300.141 196.444L301.285 183.937M286.318 183.937C285.192 184.014 284.447 184.075 284.447 184.075M286.318 183.937C288.295 183.802 291.448 183.615 293.802 183.615C296.155 183.615 299.308 183.802 301.285 183.937M301.285 183.937C302.411 184.014 303.156 184.075 303.156 184.075",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.995 183.11V180.076H296.608V183.11",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.06 183.11L291.931 183.11",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.672 183.11H297.543",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.801 188.166V194.234",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.06 189.177L290.06 193.222",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.543 189.177L297.543 193.222",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3688 168.382L54.1678 170.927L50.3494 191.626L36.5503 189.08L40.3688 168.382Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.0862,
    cy: 186.904,
    r: 1.16932,
    transform: "rotate(10.4523 44.0862 186.904)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3319 172.68L48.9316 173.529",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.622 168.381L532.421 170.926L528.603 191.625L514.804 189.079L518.622 168.381Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.34,
    cy: 186.902,
    r: 1.16932,
    transform: "rotate(10.4523 522.34 186.902)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.585 172.679L527.185 173.527",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.176 153.181L335.975 155.727L332.156 176.425L318.357 173.88L322.176 153.181Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.893,
    cy: 171.703,
    r: 1.16932,
    transform: "rotate(10.4523 325.893 171.703)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.139 157.479L330.738 158.328",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.831 309.87L257.63 312.416L253.811 333.115L240.012 330.569L243.831 309.87Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.548,
    cy: 328.392,
    r: 1.16932,
    transform: "rotate(10.4523 247.548 328.392)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.794 314.168L252.394 315.017",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.084 309.868L735.883 312.414L732.064 333.113L718.265 330.567L722.084 309.868Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 725.801,
    cy: 328.39,
    r: 1.16932,
    transform: "rotate(10.4523 725.801 328.39)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.047 314.167L730.646 315.015",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.04 503.978L569.839 506.524L566.021 527.222L552.222 524.677L556.04 503.978Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.758,
    cy: 522.5,
    r: 1.16932,
    transform: "rotate(10.4523 559.758 522.5)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.003 508.276L564.603 509.125",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.421 306.923L357.393 298.177L370.513 314.636L359.54 323.382L346.421 306.923Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.84,
    cy: 316.266,
    r: 1.16932,
    transform: "rotate(-38.5576 362.84 316.266)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.265 306.751L355.923 303.836",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.008 400.469L395.981 391.723L409.1 408.182L398.127 416.928L385.008 400.469Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.427,
    cy: 409.812,
    r: 1.16932,
    transform: "rotate(-38.5576 401.427 409.812)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.853 400.297L394.51 397.381",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.293 499.861L301.266 491.115L314.385 507.574L303.412 516.32L290.293 499.861Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.712,
    cy: 509.204,
    r: 1.16932,
    transform: "rotate(-38.5576 306.712 509.204)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.138 499.689L299.795 496.774",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07 402.169L175.928 396.55L184.357 415.836L171.499 421.456L163.07 402.169Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.523,
    cy: 415.431,
    r: 1.16932,
    transform: "rotate(-23.6075 176.523 415.431)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.761 403.51L173.047 401.637",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.323 402.167L654.181 396.548L662.61 415.834L649.752 421.454L641.323 402.167Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654.776,
    cy: 415.43,
    r: 1.16932,
    transform: "rotate(-23.6075 654.776 415.43)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.014 403.509L651.3 401.635",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0273 382.223L40.9358 376.721L49.1878 396.084L36.2793 401.585L28.0273 382.223Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.358,
    cy: 395.607,
    r: 1.16932,
    transform: "rotate(-23.0827 41.358 395.607)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7056 383.616L38.0084 381.782",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.11 394.886L516.018 389.384L524.27 408.747L511.362 414.248L503.11 394.886Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.441,
    cy: 408.271,
    r: 1.16932,
    transform: "rotate(-23.0827 516.441 408.271)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.788 396.279L513.091 394.445",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6085 526.195L55.7872 531.013L48.5597 550.781L35.381 545.963L42.6085 526.195Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.1752,
    cy: 545.077,
    r: 1.16932,
    transform: "rotate(20.0833 43.1752 545.077)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.797 531.096L50.1899 532.702",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 541.411L492.28 533.212L504.578 550.293L493.191 558.492L480.893 541.411Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.835,
    cy: 551.546,
    r: 1.16932,
    transform: "rotate(-35.753 496.835 551.546)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.739 541.524L490.534 538.791",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8313 594.576L97.804 585.83L110.923 602.289L99.9504 611.035L86.8313 594.576Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.208 564.174L190.18 555.428L203.3 571.887L192.327 580.633L179.208 564.174Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.627,
    cy: 573.517,
    r: 1.16932,
    transform: "rotate(-38.5576 195.627 573.517)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.052 564.002L188.709 561.087",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.799 569.26L670.772 560.513L683.891 576.972L672.919 585.719L659.799 569.26Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676.218,
    cy: 578.603,
    r: 1.16932,
    transform: "rotate(-38.5576 676.218 578.603)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.644 569.088L669.301 566.172",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.668 160.197H180.377V175.398H161.668V160.197Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.023,
    cy: 171.89,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.023,
    cy: 180.076,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.023 175.983V180.076",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.921 160.195H658.63V175.396H639.921V160.195Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 649.276,
    cy: 171.889,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.275,
    cy: 180.074,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.276 175.981V180.074",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.077 278.299L228.63 296.943L213.481 298.205L211.928 279.56L227.077 278.299Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.201,
    cy: 288.592,
    r: 1.16932,
    transform: "rotate(85.2386 216.201 288.592)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.043,
    cy: 289.271,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(85.2386 208.043 289.271)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.122 288.931L208.043 289.271",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.33 278.297L706.883 296.942L691.734 298.204L690.181 279.559L705.33 278.297Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.454,
    cy: 288.59,
    r: 1.16932,
    transform: "rotate(85.2386 694.454 288.59)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 686.297,
    cy: 289.269,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(85.2386 686.297 289.269)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.375 288.93L686.297 289.27",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.725 330.918H132.435V346.119H113.725V330.918Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.08,
    cy: 342.611,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.08,
    cy: 350.796,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.08 346.704V350.796",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.979 330.916H610.688V346.117H591.979V330.916Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.333,
    cy: 342.609,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.333,
    cy: 350.795,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.333 346.702V350.795",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.658 353.135H249.367V368.336H230.658V353.135Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.013,
    cy: 364.828,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.012,
    cy: 373.014,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.013 368.921V373.014",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.911 353.134H727.62V368.335H708.911V353.134Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.265,
    cy: 364.827,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 718.265,
    cy: 373.012,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.265 368.92V373.012",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.781 387.046H450.49V402.247H431.781V387.046Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.136,
    cy: 398.739,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.136,
    cy: 406.924,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.136 402.831V406.924",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.489 447.436L251.384 461.702L239.793 451.867L251.897 437.601L263.489 447.436Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.519,
    cy: 447.004,
    r: 1.16932,
    transform: "rotate(130.314 248.519 447.004)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.279,
    cy: 441.708,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(130.314 242.279 441.708)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.399 444.356L242.279 441.708",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.742 447.434L729.637 461.7L718.046 451.865L730.151 437.599L741.742 447.434Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726.773,
    cy: 447.002,
    r: 1.16932,
    transform: "rotate(130.314 726.773 447.002)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 720.531,
    cy: 441.706,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(130.314 720.531 441.706)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.652 444.354L720.531 441.706",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.959 482.93H161.668V498.131H142.959V482.93Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.313,
    cy: 494.623,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.313,
    cy: 502.809,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.313 498.716V502.809",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.211 482.928H639.921V498.129H621.211V482.928Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.566,
    cy: 494.621,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 630.566,
    cy: 502.807,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.566 498.714V502.807",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.389 554.942L343.942 540.226L355.899 549.612L344.346 564.329L332.389 554.942Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.67,
    cy: 554.805,
    r: 1.16932,
    transform: "rotate(-51.8682 335.67 554.805)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.109,
    cy: 559.859,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(-51.8682 342.109 559.859)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.889 557.332L342.109 559.859",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47021 413.738L18.8943 406.924L24.4309 421.081L7.00675 427.895L1.47021 413.738Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4419,
    cy: 421.221,
    r: 1.16932,
    transform: "rotate(-21.3594 14.4419 421.221)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4226,
    cy: 428.844,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(-21.3594 17.4226 428.844)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9326 425.033L17.4232 428.844",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.522 420.755L481.946 413.941L487.483 428.098L470.059 434.912L464.522 420.755Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.493,
    cy: 428.238,
    r: 1.16932,
    transform: "rotate(-21.3594 477.493 428.238)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.474,
    cy: 435.861,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(-21.3594 480.474 435.861)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.984 432.049L480.475 435.861",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.986 256.081H320.696V271.282H301.986V256.081Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.341,
    cy: 267.774,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.341,
    cy: 275.96,
    rx: 3.50797,
    ry: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.341 271.867V275.96",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.993 80.0077L395.973 74.8358L400.175 89.4446L382.195 94.6165L377.993 80.0077Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.215,
    cy: 88.6591,
    r: 1.16932,
    transform: "rotate(-16.0478 390.215 88.6591)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.477,
    cy: 96.5257,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(-16.0478 392.477 96.5257)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.346 92.5924L392.478 96.5256",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.209 4.00171L418.189 -1.17022L422.392 13.4386L404.412 18.6105L400.209 4.00171Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.432,
    cy: 12.6533,
    r: 1.16932,
    transform: "rotate(-16.0478 412.432 12.6533)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.695,
    cy: 20.5199,
    rx: 3.50797,
    ry: 1.16932,
    transform: "rotate(-16.0478 414.695 20.5199)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.563 16.5865L414.695 20.5197",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.128 149.673L144.128 144.995",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.943 135.75V144.995H152.313V135.641",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45 126.286H144.128H148.805V141.487H144.128H139.45V126.286Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45 130.964H141.789",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.467 130.964H148.805",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45 134.472H141.789",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.467 134.472H148.805",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45 149.673H148.805",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.128,
    cy: 137.98,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.381 149.671L622.381 144.994",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.196 135.748V144.994H630.566V135.639",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.704 126.285H622.381H627.058V141.486H622.381H617.704V126.285Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.704 130.962H620.042",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.72 130.962H627.058",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.704 134.47H620.042",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.72 134.47H627.058",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.704 149.671H627.058",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 622.381,
    cy: 137.978,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.083 258.641L160.5 254.24",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.669 248.31L152.798 257.01L168.202 251.469L165.036 242.667",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.766 238.218L154.168 236.635L158.569 235.052L163.714 249.356L159.313 250.939L154.911 252.522L149.766 238.218Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.349 242.619L153.55 241.827",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.952 240.244L160.153 239.453",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.536 245.92L154.737 245.128",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.139 243.545L161.34 242.754",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.682 260.224L166.485 257.058",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.125,
    cy: 247.638,
    r: 1.16932,
    transform: "rotate(-19.7828 158.125 247.638)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.337 258.639L638.754 254.238",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.922 248.308L631.051 257.008L646.456 251.468L643.29 242.665",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.021 238.216L632.422 236.633L636.823 235.05L641.968 249.354L637.567 250.937L633.165 252.52L628.021 238.216Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.604 242.617L631.804 241.826",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.205 240.243L638.406 239.451",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.791 245.918L632.991 245.127",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.392 243.543L639.593 242.752",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.936 260.222L644.739 257.056",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.379,
    cy: 247.636,
    r: 1.16932,
    transform: "rotate(-19.7828 636.379 247.636)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.882 240.622L307.849 235.945",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.598 226.757L299.664 236.003L316.034 235.887L315.968 226.532",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.039 217.269L307.717 217.236L312.394 217.203L312.502 232.404L307.825 232.437L303.147 232.47L303.039 217.269Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.072 221.946L305.411 221.93",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.088 221.897L312.427 221.88",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.098 225.454L305.436 225.438",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.113 225.404L312.451 225.388",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.205 240.655L312.56 240.589",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.8,
    cy: 228.929,
    r: 1.16932,
    transform: "rotate(-0.406924 307.8 228.929)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.671 135.298L453.955 132.457",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.639 133.346L448.984 138.961L458.926 125.954L451.494 120.274",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.25 124.812L439.091 121.096L441.931 117.38L454.008 126.611L451.168 130.327L448.327 134.043L436.25 124.812Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.967 127.652L441.387 125.794",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.227 122.078L445.647 120.22",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.754 129.783L444.174 127.925",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.014 124.208L448.434 122.35",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.831 139.014L460.512 131.582",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.381,
    cy: 128.197,
    r: 1.16932,
    transform: "rotate(-52.606 448.381 128.197)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.57 346.946L335.854 344.105",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.537 344.994L330.883 350.608L340.825 337.602L333.393 331.921",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.149 336.459L320.989 332.743L323.83 329.027L335.907 338.259L333.066 341.975L330.226 345.691L318.149 336.459Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.865 339.3L323.285 337.442",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.126 333.726L327.546 331.868",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.652 341.43L326.072 339.572",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.912 335.856L330.332 333.998",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.729 350.662L342.41 343.23",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.28,
    cy: 339.845,
    r: 1.16932,
    transform: "rotate(-52.606 330.28 339.845)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.428 63.5494L365.217 60.1486",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.918 59.0453L359.265 65.7679L371.168 54.5289L364.746 47.7272",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.971 49.7565L352.372 46.5453L355.773 43.3341L366.209 54.3868L362.808 57.5979L359.407 60.8091L348.971 49.7565Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.182 53.1572L353.882 51.5516",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.283 48.3406L358.984 46.735",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.591 55.7079L356.291 54.1023",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.692 50.891L361.392 49.2854",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.027 66.7605L371.828 60.3382",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.4,
    cy: 55.0474,
    r: 1.16932,
    transform: "rotate(-43.3571 360.4 55.0474)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.039 29.6393L120.828 26.2385",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.529 25.1354L114.877 31.858L126.78 20.619L120.357 13.8173",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.583 15.8466L107.984 12.6354L111.385 9.42424L121.821 20.4769L118.42 23.688L115.019 26.8992L104.583 15.8466Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.794 19.2469L109.494 17.6414",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.896 14.4304L114.596 12.8248",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.203 21.798L111.903 20.1924",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.303 16.9808L117.004 15.3753",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 32.8503L127.441 26.428",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.012,
    cy: 21.1373,
    r: 1.16932,
    transform: "rotate(-43.3571 116.012 21.1373)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.43 31.9784L586.218 28.5776",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.919 27.4744L580.267 34.197L592.17 22.9579L585.747 16.1563",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.973 18.1855L573.373 14.9744L576.774 11.7632L587.211 22.8159L583.81 26.027L580.409 29.2382L569.973 18.1855Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.184 21.5863L574.884 19.9807",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.285 16.7697L579.986 15.1641",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.593 24.137L577.293 22.5314",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.694 19.3201L582.394 17.7145",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.029 35.1896L592.83 28.7673",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 581.402,
    cy: 23.4765,
    r: 1.16932,
    transform: "rotate(-43.3571 581.402 23.4765)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0506 90.1176C63.4269 88.4514 65.801 88.4514 66.1774 90.1176L66.3103 90.706C66.5542 91.7858 67.7934 92.2991 68.7295 91.708L69.2395 91.386C70.6839 90.4739 72.3626 92.1526 71.4505 93.5969L71.1284 94.107C70.5373 95.0431 71.0506 96.2823 72.1305 96.5262L72.7189 96.6591C74.3851 97.0355 74.3851 99.4095 72.7189 99.7859L72.1305 99.9188C71.0506 100.163 70.5373 101.402 71.1284 102.338L71.4505 102.848C72.3626 104.292 70.6838 105.971 69.2395 105.059L68.7295 104.737C67.7934 104.146 66.5542 104.659 66.3103 105.739L66.1774 106.327C65.801 107.994 63.4269 107.994 63.0506 106.327L62.9177 105.739C62.6737 104.659 61.4345 104.146 60.4985 104.737L59.9884 105.059C58.5441 105.971 56.8654 104.292 57.7774 102.848L58.0995 102.338C58.6906 101.402 58.1773 100.163 57.0975 99.9188L56.509 99.7859C54.8429 99.4095 54.8429 97.0355 56.509 96.6591L57.0975 96.5262C58.1773 96.2823 58.6906 95.0431 58.0995 94.107L57.7774 93.5969C56.8654 92.1526 58.5441 90.4739 59.9884 91.386L60.4985 91.708C61.4345 92.2991 62.6737 91.7858 62.9177 90.706L63.0506 90.1176Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6173 98.2229C66.6173 99.3293 65.7203 100.226 64.6138 100.226C63.5073 100.226 62.6104 99.3293 62.6104 98.2229C62.6104 97.1164 63.5073 96.2194 64.6138 96.2194C65.7203 96.2194 66.6173 97.1164 66.6173 98.2229Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.304 90.116C541.68 88.4498 544.055 88.4498 544.431 90.116L544.564 90.7044C544.808 91.7843 546.047 92.2976 546.983 91.7065L547.493 91.3844C548.937 90.4723 550.616 92.151 549.704 93.5954L549.382 94.1054C548.791 95.0415 549.304 96.2807 550.384 96.5246L550.972 96.6575C552.639 97.0339 552.639 99.408 550.972 99.7843L550.384 99.9172C549.304 100.161 548.791 101.4 549.382 102.336L549.704 102.846C550.616 104.291 548.937 105.97 547.493 105.057L546.983 104.735C546.047 104.144 544.808 104.658 544.564 105.737L544.431 106.326C544.055 107.992 541.68 107.992 541.304 106.326L541.171 105.737C540.927 104.658 539.688 104.144 538.752 104.735L538.242 105.057C536.798 105.97 535.119 104.291 536.031 102.846L536.353 102.336C536.944 101.4 536.431 100.161 535.351 99.9172L534.763 99.7843C533.096 99.408 533.096 97.0339 534.763 96.6575L535.351 96.5246C536.431 96.2807 536.944 95.0415 536.353 94.1054L536.031 93.5954C535.119 92.151 536.798 90.4723 538.242 91.3844L538.752 91.7065C539.688 92.2976 540.927 91.7843 541.171 90.7044L541.304 90.116Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.871 98.2209C544.871 99.3274 543.974 100.224 542.867 100.224C541.761 100.224 540.864 99.3274 540.864 98.2209C540.864 97.1144 541.761 96.2174 542.867 96.2174C543.974 96.2174 544.871 97.1144 544.871 98.2209Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.079 124.028C222.455 122.362 224.829 122.362 225.205 124.028L225.338 124.616C225.582 125.696 226.822 126.21 227.758 125.618L228.268 125.296C229.712 124.384 231.391 126.063 230.479 127.507L230.157 128.017C229.565 128.953 230.079 130.193 231.159 130.437L231.747 130.569C233.413 130.946 233.413 133.32 231.747 133.696L231.159 133.829C230.079 134.073 229.565 135.312 230.157 136.248L230.479 136.758C231.391 138.203 229.712 139.881 228.268 138.969L227.758 138.647C226.822 138.056 225.582 138.57 225.338 139.649L225.205 140.238C224.829 141.904 222.455 141.904 222.079 140.238L221.946 139.649C221.702 138.57 220.463 138.056 219.527 138.647L219.016 138.969C217.572 139.881 215.893 138.203 216.806 136.758L217.128 136.248C217.719 135.312 217.205 134.073 216.126 133.829L215.537 133.696C213.871 133.32 213.871 130.946 215.537 130.569L216.126 130.437C217.205 130.193 217.719 128.953 217.128 128.017L216.806 127.507C215.893 126.063 217.572 124.384 219.016 125.296L219.527 125.618C220.463 126.21 221.702 125.696 221.946 124.616L222.079 124.028Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.645 132.133C225.645 133.24 224.748 134.137 223.642 134.137C222.535 134.137 221.638 133.24 221.638 132.133C221.638 131.027 222.535 130.13 223.642 130.13C224.748 130.13 225.645 131.027 225.645 132.133Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.331 124.026C700.708 122.36 703.082 122.36 703.458 124.026L703.591 124.615C703.835 125.695 705.074 126.208 706.01 125.617L706.52 125.295C707.964 124.383 709.643 126.061 708.731 127.506L708.409 128.016C707.818 128.952 708.331 130.191 709.411 130.435L710 130.568C711.666 130.944 711.666 133.318 710 133.695L709.411 133.828C708.331 134.072 707.818 135.311 708.409 136.247L708.731 136.757C709.643 138.201 707.964 139.88 706.52 138.968L706.01 138.646C705.074 138.055 703.835 138.568 703.591 139.648L703.458 140.236C703.082 141.902 700.708 141.902 700.331 140.236L700.198 139.648C699.954 138.568 698.715 138.055 697.779 138.646L697.269 138.968C695.825 139.88 694.146 138.201 695.058 136.757L695.38 136.247C695.971 135.311 695.458 134.072 694.378 133.828L693.79 133.695C692.123 133.318 692.123 130.944 693.79 130.568L694.378 130.435C695.458 130.191 695.971 128.952 695.38 128.016L695.058 127.506C694.146 126.061 695.825 124.383 697.269 125.295L697.779 125.617C698.715 126.208 699.954 125.695 700.198 124.615L700.331 124.026Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.898 132.131C703.898 133.238 703.001 134.135 701.895 134.135C700.788 134.135 699.891 133.238 699.891 132.131C699.891 131.025 700.788 130.128 701.895 130.128C703.001 130.128 703.898 131.025 703.898 132.131Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.164 193.018C333.54 191.352 335.915 191.352 336.291 193.018L336.424 193.607C336.668 194.687 337.907 195.2 338.843 194.609L339.353 194.287C340.797 193.375 342.476 195.054 341.564 196.498L341.242 197.008C340.651 197.944 341.164 199.183 342.244 199.427L342.832 199.56C344.499 199.936 344.499 202.31 342.832 202.687L342.244 202.82C341.164 203.064 340.651 204.303 341.242 205.239L341.564 205.749C342.476 207.193 340.797 208.872 339.353 207.96L338.843 207.638C337.907 207.047 336.668 207.56 336.424 208.64L336.291 209.228C335.915 210.895 333.54 210.895 333.164 209.228L333.031 208.64C332.787 207.56 331.548 207.047 330.612 207.638L330.102 207.96C328.658 208.872 326.979 207.193 327.891 205.749L328.213 205.239C328.804 204.303 328.291 203.064 327.211 202.82L326.623 202.687C324.956 202.31 324.956 199.936 326.623 199.56L327.211 199.427C328.291 199.183 328.804 197.944 328.213 197.008L327.891 196.498C326.979 195.054 328.658 193.375 330.102 194.287L330.612 194.609C331.548 195.2 332.787 194.687 333.031 193.607L333.164 193.018Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.731 201.124C336.731 202.23 335.834 203.127 334.727 203.127C333.621 203.127 332.724 202.23 332.724 201.124C332.724 200.017 333.621 199.12 334.727 199.12C335.834 199.12 336.731 200.017 336.731 201.124Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.509 106.488C411.885 104.822 414.259 104.822 414.636 106.488L414.769 107.076C415.012 108.156 416.252 108.669 417.188 108.078L417.698 107.756C419.142 106.844 420.821 108.523 419.909 109.967L419.587 110.477C418.996 111.413 419.509 112.652 420.589 112.896L421.177 113.029C422.843 113.406 422.843 115.78 421.177 116.156L420.589 116.289C419.509 116.533 418.996 117.772 419.587 118.708L419.909 119.218C420.821 120.663 419.142 122.341 417.698 121.429L417.188 121.107C416.252 120.516 415.012 121.029 414.769 122.109L414.636 122.698C414.259 124.364 411.885 124.364 411.509 122.698L411.376 122.109C411.132 121.029 409.893 120.516 408.957 121.107L408.447 121.429C407.002 122.341 405.324 120.663 406.236 119.218L406.558 118.708C407.149 117.772 406.636 116.533 405.556 116.289L404.967 116.156C403.301 115.78 403.301 113.406 404.967 113.029L405.556 112.896C406.636 112.652 407.149 111.413 406.558 110.477L406.236 109.967C405.324 108.523 407.002 106.844 408.447 107.756L408.957 108.078C409.893 108.669 411.132 108.156 411.376 107.076L411.509 106.488Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.075 114.593C415.075 115.7 414.178 116.597 413.072 116.597C411.965 116.597 411.068 115.7 411.068 114.593C411.068 113.487 411.965 112.59 413.072 112.59C414.178 112.59 415.075 113.487 415.075 114.593Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 57.3764C174.513 55.7102 176.887 55.7102 177.263 57.3764L177.396 57.9648C177.64 59.0446 178.879 59.5579 179.815 58.9668L180.325 58.6447C181.77 57.7327 183.449 59.4114 182.536 60.8557L182.214 61.3658C181.623 62.3018 182.137 63.541 183.216 63.785L183.805 63.9179C185.471 64.2943 185.471 66.6683 183.805 67.0447L183.216 67.1776C182.137 67.4215 181.623 68.6607 182.214 69.5968L182.536 70.1069C183.449 71.5512 181.77 73.2299 180.325 72.3178L179.815 71.9957C178.879 71.4047 177.64 71.9179 177.396 72.9978L177.263 73.5862C176.887 75.2524 174.513 75.2524 174.137 73.5862L174.004 72.9978C173.76 71.9179 172.52 71.4047 171.584 71.9957L171.074 72.3178C169.63 73.2299 167.951 71.5512 168.863 70.1069L169.185 69.5968C169.777 68.6607 169.263 67.4215 168.183 67.1776L167.595 67.0447C165.929 66.6683 165.929 64.2943 167.595 63.9179L168.183 63.785C169.263 63.541 169.777 62.3018 169.185 61.3658L168.863 60.8557C167.951 59.4114 169.63 57.7327 171.074 58.6447L171.584 58.9668C172.52 59.5579 173.76 59.0446 174.004 57.9648L174.137 57.3764Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.703 65.4816C177.703 66.5881 176.806 67.4851 175.7 67.4851C174.593 67.4851 173.696 66.5881 173.696 65.4816C173.696 64.3751 174.593 63.4781 175.7 63.4781C176.806 63.4781 177.703 64.3751 177.703 65.4816Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.389 57.3749C652.766 55.7087 655.14 55.7087 655.516 57.3749L655.649 57.9633C655.893 59.0432 657.132 59.5565 658.068 58.9654L658.578 58.6433C660.023 57.7312 661.701 59.41 660.789 60.8543L660.467 61.3643C659.876 62.3004 660.389 63.5396 661.469 63.7835L662.058 63.9164C663.724 64.2928 663.724 66.6669 662.058 67.0432L661.469 67.1761C660.389 67.4201 659.876 68.6593 660.467 69.5953L660.789 70.1054C661.701 71.5497 660.023 73.2284 658.578 72.3164L658.068 71.9943C657.132 71.4032 655.893 71.9165 655.649 72.9963L655.516 73.5848C655.14 75.251 652.766 75.251 652.389 73.5848L652.256 72.9963C652.012 71.9165 650.773 71.4032 649.837 71.9943L649.327 72.3164C647.883 73.2284 646.204 71.5497 647.116 70.1054L647.438 69.5953C648.029 68.6593 647.516 67.4201 646.436 67.1761L645.848 67.0432C644.182 66.6669 644.182 64.2928 645.848 63.9164L646.436 63.7835C647.516 63.5396 648.029 62.3004 647.438 61.3643L647.116 60.8543C646.204 59.41 647.883 57.7312 649.327 58.6433L649.837 58.9654C650.773 59.5565 652.012 59.0432 652.256 57.9633L652.389 57.3749Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.956 65.4798C655.956 66.5863 655.059 67.4833 653.953 67.4833C652.846 67.4833 651.949 66.5863 651.949 65.4798C651.949 64.3733 652.846 63.4763 653.953 63.4763C655.059 63.4763 655.956 64.3733 655.956 65.4798Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.819 16.4501C255.196 14.7839 257.57 14.7839 257.946 16.4501L258.079 17.0385C258.323 18.1184 259.562 18.6317 260.498 18.0406L261.008 17.7185C262.453 16.8064 264.131 18.4852 263.219 19.9295L262.897 20.4395C262.306 21.3756 262.819 22.6148 263.899 22.8587L264.488 22.9916C266.154 23.368 266.154 25.7421 264.488 26.1184L263.899 26.2513C262.819 26.4953 262.306 27.7345 262.897 28.6705L263.219 29.1806C264.131 30.6249 262.453 32.3036 261.008 31.3916L260.498 31.0695C259.562 30.4784 258.323 30.9917 258.079 32.0715L257.946 32.66C257.57 34.3262 255.196 34.3261 254.819 32.66L254.686 32.0715C254.442 30.9917 253.203 30.4784 252.267 31.0695L251.757 31.3916C250.313 32.3036 248.634 30.6249 249.546 29.1806L249.868 28.6705C250.459 27.7345 249.946 26.4953 248.866 26.2513L248.278 26.1184C246.612 25.7421 246.612 23.368 248.278 22.9916L248.866 22.8587C249.946 22.6148 250.459 21.3756 249.868 20.4395L249.546 19.9295C248.634 18.4851 250.313 16.8064 251.757 17.7185L252.267 18.0406C253.203 18.6317 254.442 18.1184 254.686 17.0385L254.819 16.4501Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.386 24.5554C258.386 25.6619 257.489 26.5589 256.383 26.5589C255.276 26.5589 254.379 25.6619 254.379 24.5554C254.379 23.4489 255.276 22.5519 256.383 22.5519C257.489 22.5519 258.386 23.4489 258.386 24.5554Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.072 16.4487C733.449 14.7825 735.823 14.7825 736.199 16.4487L736.332 17.0372C736.576 18.117 737.815 18.6303 738.751 18.0392L739.261 17.7171C740.706 16.8051 742.384 18.4838 741.472 19.9281L741.15 20.4382C740.559 21.3742 741.072 22.6134 742.152 22.8574L742.741 22.9903C744.407 23.3666 744.407 25.7407 742.741 26.1171L742.152 26.25C741.072 26.4939 740.559 27.7331 741.15 28.6692L741.472 29.1792C742.384 30.6235 740.706 32.3023 739.261 31.3902L738.751 31.0681C737.815 30.477 736.576 30.9903 736.332 32.0702L736.199 32.6586C735.823 34.3248 733.449 34.3248 733.072 32.6586L732.94 32.0702C732.696 30.9903 731.456 30.477 730.52 31.0681L730.01 31.3902C728.566 32.3023 726.887 30.6235 727.799 29.1792L728.121 28.6692C728.712 27.7331 728.199 26.4939 727.119 26.25L726.531 26.1171C724.865 25.7407 724.865 23.3666 726.531 22.9903L727.119 22.8574C728.199 22.6134 728.712 21.3742 728.121 20.4382L727.799 19.9281C726.887 18.4838 728.566 16.8051 730.01 17.7171L730.52 18.0392C731.456 18.6303 732.696 18.117 732.94 17.0372L733.072 16.4487Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.64 24.5535C736.64 25.66 735.743 26.557 734.636 26.557C733.53 26.557 732.633 25.66 732.633 24.5535C732.633 23.447 733.53 22.55 734.636 22.55C735.743 22.55 736.64 23.447 736.64 24.5535Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5906 238.622C80.967 236.956 83.3411 236.956 83.7174 238.622L83.8503 239.21C84.0943 240.29 85.3335 240.803 86.2695 240.212L86.7796 239.89C88.2239 238.978 89.9026 240.657 88.9906 242.101L88.6685 242.611C88.0774 243.547 88.5907 244.786 89.6705 245.03L90.259 245.163C91.9252 245.54 91.9251 247.914 90.259 248.29L89.6705 248.423C88.5907 248.667 88.0774 249.906 88.6685 250.842L88.9906 251.352C89.9026 252.797 88.2239 254.475 86.7796 253.563L86.2695 253.241C85.3335 252.65 84.0943 253.163 83.8503 254.243L83.7174 254.832C83.3411 256.498 80.967 256.498 80.5906 254.832L80.4577 254.243C80.2138 253.163 78.9746 252.65 78.0385 253.241L77.5285 253.563C76.0841 254.475 74.4054 252.797 75.3175 251.352L75.6396 250.842C76.2307 249.906 75.7174 248.667 74.6375 248.423L74.0491 248.29C72.3829 247.914 72.3829 245.54 74.0491 245.163L74.6375 245.03C75.7174 244.786 76.2307 243.547 75.6396 242.611L75.3175 242.101C74.4054 240.657 76.0842 238.978 77.5285 239.89L78.0385 240.212C78.9746 240.803 80.2138 240.29 80.4577 239.21L80.5906 238.622Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1575 246.727C84.1575 247.833 83.2605 248.73 82.154 248.73C81.0475 248.73 80.1505 247.833 80.1505 246.727C80.1505 245.62 81.0475 244.723 82.154 244.723C83.2605 244.723 84.1575 245.62 84.1575 246.727Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.844 238.62C559.22 236.954 561.594 236.954 561.971 238.62L562.104 239.209C562.347 240.288 563.587 240.802 564.523 240.211L565.033 239.889C566.477 238.976 568.156 240.655 567.244 242.1L566.922 242.61C566.331 243.546 566.844 244.785 567.924 245.029L568.512 245.162C570.178 245.538 570.178 247.912 568.512 248.288L567.924 248.421C566.844 248.665 566.331 249.905 566.922 250.841L567.244 251.351C568.156 252.795 566.477 254.474 565.033 253.562L564.523 253.24C563.587 252.648 562.347 253.162 562.104 254.242L561.971 254.83C561.594 256.496 559.22 256.496 558.844 254.83L558.711 254.242C558.467 253.162 557.228 252.648 556.292 253.24L555.782 253.562C554.337 254.474 552.659 252.795 553.571 251.351L553.893 250.841C554.484 249.905 553.971 248.665 552.891 248.421L552.302 248.288C550.636 247.912 550.636 245.538 552.302 245.162L552.891 245.029C553.971 244.785 554.484 243.546 553.893 242.61L553.571 242.1C552.659 240.655 554.337 238.976 555.782 239.889L556.292 240.211C557.228 240.802 558.467 240.288 558.711 239.209L558.844 238.62Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.411 246.726C562.411 247.832 561.514 248.729 560.407 248.729C559.301 248.729 558.404 247.832 558.404 246.726C558.404 245.619 559.301 244.722 560.407 244.722C561.514 244.722 562.411 245.619 562.411 246.726Z",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.297 95.9717C148.886 95.6066 148.539 95.2305 148.236 94.8277L149.297 95.9717Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.236 94.8277C148.539 95.2305 148.886 95.6066 149.297 95.9717L148.236 94.8277ZM148.236 94.8277C147.727 94.1481 147.869 93.215 148.43 92.5758L148.907 92.0314C150 90.7854 149.838 88.8842 148.549 87.8426L147.759 87.2049C146.818 86.4439 145.48 86.3122 144.508 87.0353C143.204 88.0046 142.361 89.0177 141.91 90.2206C141.697 90.7901 141.785 91.4187 142.037 91.972C143.36 94.8749 144.257 96.3782 146.467 98.2224M151.729 97.6377L153.05 98.3129C153.481 98.5454 154.016 98.4494 154.338 98.0816L155.336 96.9445C156.373 95.7629 158.161 95.6095 159.384 96.5975L160.116 97.1892C161.166 98.038 161.532 99.5195 160.777 100.639C160.064 101.695 159.269 102.521 158.331 103.197C157.733 103.628 156.963 103.727 156.253 103.524C155.038 103.176 154.008 102.776 152.898 102.315C152.351 102.088 149.897 100.819 149.39 100.561",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.457 97.3198L160.282 101.219",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.641 84.3256L140.62 105.238",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.199 88.2229L149.024 92.1216",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.55 95.97C627.138 95.6049 626.791 95.2288 626.489 94.826L627.55 95.97Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.489 94.826C626.791 95.2288 627.138 95.6049 627.55 95.97L626.489 94.826ZM626.489 94.826C625.979 94.1464 626.121 93.2133 626.682 92.5741L627.16 92.0297C628.253 90.7837 628.09 88.8825 626.801 87.8408L626.012 87.2032C625.07 86.4422 623.732 86.3105 622.76 87.0336C621.457 88.0029 620.614 89.016 620.163 90.2189C619.949 90.7884 620.038 91.417 620.29 91.9703C621.612 94.8732 622.51 96.3765 624.719 98.2207M629.981 97.636L631.302 98.3112C631.733 98.5437 632.268 98.4476 632.591 98.0799L633.588 96.9428C634.625 95.7612 636.413 95.6078 637.636 96.5958L638.368 97.1875C639.419 98.0363 639.784 99.5177 639.029 100.637C638.317 101.693 637.522 102.52 636.584 103.195C635.985 103.626 635.215 103.725 634.506 103.522C633.291 103.175 632.261 102.775 631.15 102.313C630.603 102.086 628.15 100.817 627.642 100.559",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.71 97.3186L638.535 101.217",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.894 84.324L618.873 105.236",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.451 88.2214L627.276 92.1201",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.833 25.8124C311.421 25.4473 311.074 25.0712 310.772 24.6684L311.833 25.8124Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.772 24.6684C311.074 25.0712 311.421 25.4473 311.833 25.8124L310.772 24.6684ZM310.772 24.6684C310.262 23.9888 310.404 23.0557 310.965 22.4165L311.442 21.8721C312.536 20.6261 312.373 18.7249 311.084 17.6832L310.295 17.0456C309.353 16.2846 308.015 16.1529 307.043 16.876C305.74 17.8453 304.897 18.8584 304.446 20.0613C304.232 20.6308 304.32 21.2594 304.573 21.8127C305.895 24.7156 306.793 26.2189 309.002 28.0631M314.264 27.4784L315.585 28.1536C316.016 28.3861 316.551 28.2901 316.874 27.9223L317.871 26.7852C318.908 25.6036 320.696 25.4502 321.919 26.4382L322.651 27.0299C323.702 27.8787 324.067 29.3602 323.312 30.4794C322.6 31.5357 321.805 32.3621 320.867 33.0376C320.268 33.4685 319.498 33.5673 318.789 33.3645C317.574 33.017 316.544 32.617 315.433 32.1557C314.886 31.9284 312.433 30.6599 311.925 30.4018",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.993 27.1605L322.818 31.0592",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.177 14.1662L303.156 35.0785",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.734 18.0636L311.559 21.9623",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.378 369.594C404.967 369.229 404.62 368.853 404.318 368.45L405.378 369.594Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.318 368.45C404.62 368.853 404.967 369.229 405.378 369.594L404.318 368.45ZM404.318 368.45C403.808 367.77 403.95 366.837 404.511 366.198L404.988 365.654C406.082 364.408 405.919 362.506 404.63 361.465L403.84 360.827C402.899 360.066 401.561 359.934 400.589 360.657C399.285 361.627 398.442 362.64 397.991 363.843C397.778 364.412 397.866 365.041 398.118 365.594C399.441 368.497 400.339 370 402.548 371.845M407.81 371.26L409.131 371.935C409.562 372.168 410.097 372.072 410.419 371.704L411.417 370.567C412.454 369.385 414.242 369.232 415.465 370.22L416.197 370.811C417.247 371.66 417.613 373.142 416.858 374.261C416.145 375.317 415.351 376.144 414.412 376.819C413.814 377.25 413.044 377.349 412.334 377.146C411.119 376.799 410.089 376.398 408.979 375.937C408.432 375.71 405.978 374.441 405.471 374.183",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.538 370.942L416.363 374.841",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.722 357.948L396.701 378.86",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28 361.845L405.105 365.744",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.092 421.044C278.681 420.679 278.333 420.303 278.031 419.9L279.092 421.044Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.031 419.9C278.333 420.303 278.681 420.679 279.092 421.044L278.031 419.9ZM278.031 419.9C277.521 419.221 277.663 418.287 278.224 417.648L278.702 417.104C279.795 415.858 279.632 413.957 278.343 412.915L277.554 412.277C276.612 411.516 275.275 411.385 274.302 412.108C272.999 413.077 272.156 414.09 271.705 415.293C271.492 415.863 271.58 416.491 271.832 417.044C273.155 419.947 274.052 421.451 276.261 423.295M281.523 422.71L282.844 423.385C283.275 423.618 283.81 423.522 284.133 423.154L285.131 422.017C286.168 420.835 287.956 420.682 289.178 421.67L289.911 422.262C290.961 423.111 291.327 424.592 290.572 425.711C289.859 426.767 289.064 427.594 288.126 428.269C287.527 428.7 286.757 428.799 286.048 428.596C284.833 428.249 283.803 427.849 282.693 427.388C282.145 427.16 279.692 425.892 279.185 425.634",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.252 422.392L290.077 426.291",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.435 409.398L270.414 430.31",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.993 413.295L278.818 417.194",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.344 421.043C756.933 420.677 756.586 420.301 756.283 419.899L757.344 421.043Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.283 419.899C756.586 420.301 756.933 420.677 757.344 421.043L756.283 419.899ZM756.283 419.899C755.774 419.219 755.916 418.286 756.476 417.647L756.954 417.102C758.047 415.856 757.885 413.955 756.596 412.913L755.806 412.276C754.865 411.515 753.527 411.383 752.555 412.106C751.251 413.075 750.408 414.088 749.957 415.291C749.744 415.861 749.832 416.489 750.084 417.043C751.407 419.946 752.304 421.449 754.514 423.293M759.776 422.709L761.097 423.384C761.528 423.616 762.063 423.52 762.385 423.152L763.383 422.015C764.42 420.834 766.208 420.68 767.431 421.668L768.163 422.26C769.213 423.109 769.579 424.59 768.824 425.709C768.111 426.766 767.316 427.592 766.378 428.268C765.78 428.699 765.01 428.797 764.3 428.595C763.085 428.247 762.055 427.847 760.945 427.386C760.398 427.158 757.944 425.89 757.437 425.632",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.688 409.396L748.667 430.309",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.246 413.294L757.071 417.192",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0232 364.035C81.2327 363.526 81.4736 363.074 81.7547 362.657L81.0232 364.035Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7547 362.657C81.4736 363.074 81.2327 363.526 81.0232 364.035L81.7547 362.657ZM81.7547 362.657C82.2289 361.952 83.1568 361.779 83.9448 362.098L84.6161 362.371C86.1522 362.993 87.8942 362.214 88.454 360.654L88.7967 359.7C89.2057 358.56 88.8903 357.253 87.8877 356.573C86.5437 355.661 85.3097 355.198 84.0254 355.167C83.4174 355.153 82.8528 355.443 82.4132 355.863C80.1066 358.067 78.982 359.409 77.9668 362.101M80.2492 366.879L80.046 368.348C79.9681 368.832 80.2347 369.305 80.6882 369.489L82.09 370.057C83.547 370.648 84.2798 372.286 83.7488 373.766L83.4308 374.652C82.9746 375.923 81.6958 376.756 80.3905 376.411C79.1586 376.085 78.1168 375.606 77.1703 374.942C76.5666 374.519 76.22 373.824 76.1783 373.087C76.1069 371.825 76.146 370.721 76.2165 369.521C76.2512 368.929 76.6425 366.195 76.7194 365.631",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7754 370.295L79.6801 376.134",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7519 370.918L69.4191 358.887",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6647 356.671L84.5694 362.51",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.276 364.033C559.486 363.524 559.727 363.073 560.008 362.655L559.276 364.033Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.008 362.655C559.727 363.073 559.486 363.524 559.276 364.033L560.008 362.655ZM560.008 362.655C560.482 361.95 561.41 361.777 562.198 362.097L562.869 362.369C564.405 362.992 566.147 362.213 566.707 360.653L567.05 359.698C567.459 358.558 567.143 357.251 566.141 356.571C564.797 355.659 563.563 355.196 562.279 355.166C561.671 355.151 561.106 355.441 560.666 355.861C558.36 358.065 557.235 359.407 556.22 362.1M558.502 366.877L558.299 368.347C558.221 368.83 558.488 369.303 558.941 369.487L560.343 370.056C561.8 370.646 562.533 372.284 562.002 373.764L561.684 374.65C561.228 375.921 559.949 376.754 558.644 376.409C557.412 376.083 556.37 375.604 555.423 374.94C554.82 374.517 554.473 373.822 554.432 373.085C554.36 371.824 554.399 370.719 554.47 369.519C554.504 368.927 554.896 366.193 554.973 365.629",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.028 370.293L557.933 376.132",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.004 370.916L547.672 358.885",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.917 356.67L562.822 362.508",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.54498 578.902C-1.95628 578.537 -2.30384 578.161 -2.60593 577.758L-1.54498 578.902Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.60593 577.758C-2.30384 578.161 -1.95628 578.537 -1.54498 578.902L-2.60593 577.758ZM-2.60593 577.758C-3.11571 577.078 -2.97374 576.145 -2.41291 575.506L-1.9352 574.962C-0.84192 573.716 -1.00472 571.814 -2.29388 570.773L-3.08305 570.135C-4.02479 569.374 -5.36244 569.242 -6.33468 569.965C-7.63797 570.935 -8.48113 571.948 -8.93199 573.151C-9.14544 573.72 -9.05721 574.349 -8.8051 574.902C-7.48229 577.805 -6.58495 579.308 -4.37584 581.153M0.886107 580.568L2.20739 581.243C2.63814 581.476 3.17316 581.38 3.49584 581.012L4.49356 579.875C5.53044 578.693 7.31853 578.54 8.5412 579.528L9.27357 580.119C10.324 580.968 10.6897 582.45 9.93458 583.569C9.22195 584.625 8.42709 585.452 7.48882 586.127C6.89032 586.558 6.12026 586.657 5.41098 586.454C4.19583 586.106 3.16583 585.706 2.05543 585.245C1.50814 585.018 -0.945101 583.749 -1.45254 583.491",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6145 580.25L9.43953 584.149",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79844 567.255L-10.2226 588.168",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.046 583.988C478.635 583.623 478.287 583.247 477.985 582.844L479.046 583.988Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.985 582.844C478.287 583.247 478.635 583.623 479.046 583.988L477.985 582.844ZM477.985 582.844C477.476 582.165 477.618 581.232 478.178 580.592L478.656 580.048C479.749 578.802 479.587 576.901 478.297 575.859L477.508 575.221C476.567 574.461 475.229 574.329 474.257 575.052C472.953 576.021 472.11 577.034 471.659 578.237C471.446 578.807 471.534 579.435 471.786 579.989C473.109 582.892 474.006 584.395 476.215 586.239M481.477 585.654L482.799 586.33C483.229 586.562 483.764 586.466 484.087 586.098L485.085 584.961C486.122 583.779 487.91 583.626 489.133 584.614L489.865 585.206C490.915 586.055 491.281 587.536 490.526 588.655C489.813 589.712 489.018 590.538 488.08 591.213C487.482 591.644 486.712 591.743 486.002 591.54C484.787 591.193 483.757 590.793 482.647 590.332C482.099 590.104 479.646 588.836 479.139 588.578",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.206 585.336L490.031 589.235",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.39 572.342L470.369 593.254",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.948 576.239L478.773 580.138",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.136 576.45C428.182 575.902 428.275 575.398 428.417 574.915L428.136 576.45Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.417 574.915C428.275 575.398 428.182 575.902 428.136 576.45L428.417 574.915ZM428.417 574.915C428.655 574.1 429.487 573.654 430.335 573.72L431.057 573.776C432.71 573.905 434.134 572.636 434.196 570.979L434.234 569.966C434.279 568.756 433.583 567.606 432.421 567.261C430.864 566.798 429.548 566.73 428.315 567.09C427.731 567.26 427.28 567.707 426.989 568.241C425.457 571.039 424.791 572.658 424.638 575.532M428.259 579.394L428.51 580.857C428.582 581.341 428.98 581.712 429.467 581.75L430.976 581.867C432.543 581.989 433.737 583.329 433.679 584.9L433.644 585.841C433.594 587.19 432.627 588.371 431.278 588.437C430.005 588.499 428.868 588.358 427.765 588.012C427.061 587.791 426.52 587.233 426.258 586.544C425.808 585.363 425.511 584.299 425.215 583.133C425.069 582.559 424.615 579.835 424.517 579.274",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.748 582.189L430.517 588.388",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.258 578.554L415.519 575.055",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.285 567.725L431.055 573.924",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.572 264.354C123.161 263.989 122.813 263.613 122.511 263.21L123.572 264.354Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.511 263.21C122.813 263.613 123.161 263.989 123.572 264.354L122.511 263.21ZM122.511 263.21C122.001 262.531 122.143 261.597 122.704 260.958L123.182 260.414C124.275 259.168 124.112 257.267 122.823 256.225L122.034 255.587C121.092 254.826 119.755 254.695 118.782 255.418C117.479 256.387 116.636 257.4 116.185 258.603C115.972 259.173 116.06 259.801 116.312 260.354C117.635 263.257 118.532 264.761 120.741 266.605M126.003 266.02L127.324 266.695C127.755 266.928 128.29 266.832 128.613 266.464L129.611 265.327C130.648 264.145 132.436 263.992 133.658 264.98L134.391 265.572C135.441 266.42 135.807 267.902 135.052 269.021C134.339 270.077 133.544 270.904 132.606 271.579C132.007 272.01 131.237 272.109 130.528 271.906C129.313 271.559 128.283 271.159 127.172 270.697C126.625 270.47 124.172 269.202 123.665 268.944",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.732 265.703L134.557 269.601",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.916 252.708L114.895 273.621",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.474 256.606L123.299 260.504",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.824 264.354C601.413 263.989 601.065 263.613 600.763 263.21L601.824 264.354Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.763 263.21C601.065 263.613 601.413 263.989 601.824 264.354L600.763 263.21ZM600.763 263.21C600.253 262.53 600.395 261.597 600.956 260.958L601.434 260.413C602.527 259.168 602.364 257.266 601.075 256.225L600.286 255.587C599.344 254.826 598.007 254.694 597.034 255.417C595.731 256.387 594.888 257.4 594.437 258.603C594.224 259.172 594.312 259.801 594.564 260.354C595.887 263.257 596.784 264.76 598.993 266.604M604.255 266.02L605.577 266.695C606.007 266.927 606.542 266.831 606.865 266.464L607.863 265.327C608.9 264.145 610.688 263.992 611.91 264.98L612.643 265.571C613.693 266.42 614.059 267.902 613.304 269.021C612.591 270.077 611.796 270.903 610.858 271.579C610.259 272.01 609.489 272.109 608.78 271.906C607.565 271.558 606.535 271.158 605.425 270.697C604.877 270.47 602.424 269.201 601.917 268.943",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.984 265.702L612.809 269.601",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.167 252.708L593.146 273.62",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.726 256.605L601.551 260.504",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82 130.523C373.247 130.176 373.674 129.894 374.121 129.661L372.82 130.523Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.121 129.661C373.674 129.894 373.247 130.176 372.82 130.523L374.121 129.661ZM374.121 129.661C374.874 129.267 375.772 129.558 376.312 130.215L376.772 130.775C377.824 132.055 379.727 132.202 380.963 131.098L381.72 130.422C382.623 129.616 382.97 128.317 382.413 127.241C381.668 125.798 380.804 124.802 379.69 124.163C379.162 123.86 378.528 123.845 377.941 124.005C374.863 124.841 373.234 125.483 371.057 127.365M370.783 132.652L369.903 133.847C369.604 134.234 369.612 134.778 369.923 135.156L370.884 136.324C371.882 137.539 371.744 139.328 370.572 140.375L369.869 141.002C368.862 141.901 367.341 142.023 366.358 141.096C365.431 140.222 364.744 139.304 364.229 138.269C363.901 137.609 363.928 136.833 364.243 136.166C364.782 135.023 365.343 134.071 365.978 133.05C366.291 132.547 367.939 130.331 368.276 129.872",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.493 136.383L365.866 140.514",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.479 143.6L365.079 120.461",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.291 126.744L376.664 130.875",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.04 50.3686C402.629 50.0035 402.281 49.6273 401.979 49.2246L403.04 50.3686Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.979 49.2246C402.281 49.6273 402.629 50.0035 403.04 50.3686L401.979 49.2246ZM401.979 49.2246C401.47 48.5449 401.612 47.6118 402.172 46.9727L402.65 46.4282C403.743 45.1823 403.581 43.2811 402.291 42.2394L401.502 41.6017C400.561 40.8408 399.223 40.709 398.251 41.4321C396.947 42.4014 396.104 43.4145 395.653 44.6175C395.44 45.187 395.528 45.8155 395.78 46.3688C397.103 49.2718 398 50.7751 400.209 52.6193M405.471 52.0346L406.793 52.7098C407.223 52.9423 407.758 52.8462 408.081 52.4785L409.079 51.3414C410.116 50.1597 411.904 50.0064 413.127 50.9943L413.859 51.5861C414.909 52.4349 415.275 53.9163 414.52 55.0355C413.807 56.0918 413.012 56.9183 412.074 57.5937C411.476 58.0246 410.706 58.1235 409.996 57.9206C408.781 57.5732 407.751 57.1732 406.641 56.7119C406.093 56.4845 403.64 55.2161 403.133 54.9579",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.2 51.7167L414.025 55.6154",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.384 38.7223L394.363 59.6346",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.942 42.6196L402.767 46.5183",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6937 97.053H109.012H117.234V79.5132H99.6937V97.053Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.012 97.053H99.6937V79.5132H117.234V87.7959",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.078,
    y1: 87.9907,
    x2: 110.51,
    y2: 87.9907,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.078,
    y1: 84.4826,
    x2: 112.848,
    y2: 84.4826,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.078,
    y1: 91.4985,
    x2: 108.171,
    y2: 91.4985,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.947 97.0516H587.265H595.487V79.5117H577.947V97.0516Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.265 97.0516H577.947V79.5117H595.487V87.7944",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.332,
    y1: 87.9895,
    x2: 588.763,
    y2: 87.9895,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.332,
    y1: 84.4817,
    x2: 591.102,
    y2: 84.4817,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.332,
    y1: 91.4975,
    x2: 586.424,
    y2: 91.4975,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.447 155.519H293.765H301.987V137.979H284.447V155.519Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.765 155.519H284.447V137.979H301.987V146.262",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.832,
    y1: 146.457,
    x2: 295.263,
    y2: 146.457,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.832,
    y1: 142.949,
    x2: 297.602,
    y2: 142.949,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.832,
    y1: 149.965,
    x2: 292.924,
    y2: 149.965,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.341 312.209H320.659H328.881V294.669H311.341V312.209Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.659 312.209H311.341V294.669H328.881V302.952",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.726,
    y1: 303.147,
    x2: 322.157,
    y2: 303.147,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.726,
    y1: 299.639,
    x2: 324.496,
    y2: 299.639,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.726,
    y1: 306.655,
    x2: 319.818,
    y2: 306.655,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.686 261.928H399.004H407.226V244.388H389.686V261.928Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.004 261.928H389.686V244.388H407.226V252.671",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.071,
    y1: 252.866,
    x2: 400.502,
    y2: 252.866,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.071,
    y1: 249.358,
    x2: 402.841,
    y2: 249.358,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.071,
    y1: 256.374,
    x2: 398.163,
    y2: 256.374,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.619 428.479L331.196 420.362L335.234 413.2L319.956 404.585L311.341 419.864L326.619 428.479Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.196 420.362L326.619 428.479L311.341 419.864L319.956 404.585L327.171 408.654",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.879,
    y1: 420.208,
    x2: 324.038,
    y2: 414.606,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.823,
    y1: 418.485,
    x2: 322.131,
    y2: 410.846,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.935,
    y1: 421.931,
    x2: 325.945,
    y2: 418.366,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.584 479.422H280.902H289.124V461.882H271.584V479.422Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.902 479.422H271.584V461.882H289.124V470.165",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.969,
    y1: 470.36,
    x2: 282.4,
    y2: 470.36,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.969,
    y1: 466.852,
    x2: 284.739,
    y2: 466.852,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.969,
    y1: 473.868,
    x2: 280.062,
    y2: 473.868,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.837 479.42H759.155H767.377V461.881H749.837V479.42Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.155 479.42H749.837V461.881H767.377V470.163",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.757 426.803H137.075H145.297V409.263H127.757V426.803Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.075 426.803H127.757V409.263H145.297V417.545",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.143,
    y1: 417.74,
    x2: 138.574,
    y2: 417.74,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.143,
    y1: 414.232,
    x2: 140.913,
    y2: 414.232,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.143,
    y1: 421.248,
    x2: 136.235,
    y2: 421.248,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.01 426.801H615.328H623.55V409.261H606.01V426.801Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.328 426.801H606.01V409.261H623.55V417.544",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.395,
    y1: 417.739,
    x2: 616.827,
    y2: 417.739,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.395,
    y1: 414.231,
    x2: 619.165,
    y2: 414.231,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.395,
    y1: 421.247,
    x2: 614.488,
    y2: 421.247,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.911 535.549H131.229H139.451V518.01H121.911V535.549Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.502 540.635H611.82H620.042V523.095H602.502V540.635Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.229 535.549H121.911V518.01H139.451V526.292",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.82 540.635H602.502V523.095H620.042V531.378",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.295,
    y1: 526.487,
    x2: 132.727,
    y2: 526.487,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.295,
    y1: 522.979,
    x2: 135.065,
    y2: 522.979,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.295,
    y1: 529.995,
    x2: 130.388,
    y2: 529.995,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 606.887,
    y1: 535.081,
    x2: 610.98,
    y2: 535.081,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.648 551.92H308.966H317.188V534.38H299.648V551.92Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.966 551.92H299.648V534.38H317.188V542.663",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.033,
    y1: 542.858,
    x2: 310.464,
    y2: 542.858,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.033,
    y1: 539.35,
    x2: 312.803,
    y2: 539.35,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.033,
    y1: 546.366,
    x2: 308.125,
    y2: 546.366,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.274 354.333L436.364 358.955L443.503 363.034L452.204 347.805L436.975 339.104L428.274 354.333Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.364 358.955L428.274 354.333L436.975 339.104L452.204 347.805L448.095 354.996",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.577,
    y1: 348.64,
    x2: 442.161,
    y2: 351.83,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.317,
    y1: 345.594,
    x2: 445.932,
    y2: 349.944,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.837,
    y1: 351.685,
    x2: 438.39,
    y2: 353.716,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.66169 209.865L5.42005 205.227L12.551 201.135L3.82061 185.922L-11.3921 194.652L-2.66169 209.865Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42005 205.227L-2.66169 209.865L-11.3921 194.652L3.82061 185.922L7.94329 193.106",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.36924,
    y1: 199.823,
    x2: 2.20875,
    y2: 196.622,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5.11485,
    y1: 196.78,
    x2: 2.4915,
    y2: 192.415,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.62315,
    y1: 202.865,
    x2: 1.92648,
    y2: 200.828,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.099 194.664L487.181 190.026L494.312 185.934L485.581 170.721L470.369 179.452L479.099 194.664Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.181 190.026L479.099 194.664L470.369 179.452L485.581 170.721L489.704 177.905",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 478.392,
    y1: 184.622,
    x2: 483.97,
    y2: 181.421,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.646,
    y1: 181.579,
    x2: 484.252,
    y2: 177.214,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.138,
    y1: 187.665,
    x2: 483.687,
    y2: 185.627,
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0164,
    y: 118.101,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6779 121.609L91.5085 121.609",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6779 128.625L91.5085 128.625",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.694 122.778L104.371 126.286L109.049 122.778",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.678 125.117H90.3394",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.27,
    y: 118.099,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.931 121.607L569.762 121.607",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.931 128.623L569.762 128.623",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.947 122.777L582.625 126.285L587.302 122.777",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.931 125.115H568.593",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.935,
    y: 78.3439,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.596 81.8519L422.427 81.8519",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.596 88.8678L422.427 88.8678",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.612 83.0212L435.289 86.5292L439.967 83.0212",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.596 85.3597H421.257",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.551,
    y: 265.571,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(24.4379 357.551 265.571)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.971 267.797L352.906 267.314",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.068 274.185L350.004 273.701",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.874 271.764L362.681 276.893L368.391 275.634",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.519 270.991L350.39 270.023",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.907,
    y: 240.88,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.568 244.389L263.399 244.389",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.568 251.404L263.399 251.404",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.584 245.558L276.261 249.066L280.939 245.558",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.569 247.896H262.23",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.16,
    y: 240.879,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.821 244.387L741.652 244.387",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.821 251.402L741.652 251.402",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.837 245.556L754.514 249.064L759.191 245.556",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.821 247.894H740.482",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.348,
    y: 378.137,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(-45.3424 264.348 378.137)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.199 382.266L264.377 383.098",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19 387.197L269.368 388.029",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.962 378.097L276.745 377.236L277.537 371.443",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.695 384.732L266.051 386.395",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.601,
    y: 378.135,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(-45.3424 742.601 378.135)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.453 382.264L742.631 383.096",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.443 387.196L747.621 388.027",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.216 378.095L754.998 377.234L755.791 371.441",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.948 384.73L744.304 386.394",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.223,
    y: 347.289,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.885 350.797L182.716 350.797",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.885 357.813L182.716 357.813",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.901 351.966L195.578 355.474L200.256 351.966",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.885 354.305H181.546",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.476,
    y: 347.287,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.138 350.795L660.968 350.795",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.138 357.811L660.968 357.811",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.153 351.964L673.83 355.472L678.508 351.964",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.138 354.303H659.799",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.76,
    y: 381.199,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.422 384.707L345.253 384.707",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.422 391.723L345.253 391.723",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.437 385.876L358.114 389.384L362.791 385.876",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.422 388.215H344.083",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.187,
    y: 458.831,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(-178.588 393.187 458.831)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.612 455.382L396.781 455.411",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.785 448.368L396.954 448.397",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.627 454.04L384.037 450.418L379.275 453.809",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.698 451.875L398.036 451.932",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.897,
    y: 506.316,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.559 509.824L332.39 509.824",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.559 516.84L332.39 516.84",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.574 510.994L345.252 514.502L349.929 510.994",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.559 513.332H331.22",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.5,
    y: 536.017,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(150.186 458.5 536.017)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.785 531.811L459.799 531.229",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.297 525.724L456.311 525.142",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.117 534.284L446.314 533.566L444 538.935",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.041 528.767L459.07 527.604",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.399,
    y: 570.629,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06 574.137L259.891 574.137",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06 581.153L259.891 581.153",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.076 575.307L272.753 578.815L277.431 575.307",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06 577.645H258.721",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 743.991,
    y: 575.715,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.652 579.223L740.482 579.223",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.652 586.239L740.482 586.239",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.668 580.392L753.345 583.9L758.022 580.392",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.652 582.731H739.313",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.054,
    y: 460.713,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.716 464.221L181.547 464.221",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.716 471.237L181.547 471.237",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.732 465.39L194.409 468.898L199.087 465.39",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.716 467.729H180.377",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.308,
    y: 460.712,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.969 464.219L659.8 464.219",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.969 471.235L659.8 471.235",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.985 465.389L672.662 468.897L677.339 465.389",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.969 467.728H658.63",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.307,
    y: 514.501,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9685 518.01L72.7992 518.01",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9685 525.026L72.7992 525.026",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9841 519.179L85.6614 522.687L90.3387 519.179",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.968 521.518H71.6294",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.05298,
    y: 370.675,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.37573 375.352L0.301558 378.86L4.97885 375.352",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.2,
    y: 370.673,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.861 374.181L465.692 374.181",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.861 381.197L465.692 381.197",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.878 375.351L478.555 378.859L483.232 375.351",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.862 377.689H464.523",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.679,
    y: 49.0439,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(-17.9937 266.679 49.0439)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.539 53.1029L264.426 53.4641",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.706 59.7756L266.594 60.1368",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.572 52.0474L278.104 53.9389L281.469 49.1576",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.622 56.4391L264.398 57.1615",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.931,
    y: 49.0422,
    width: 18.7092,
    height: 14.0319,
    transform: "rotate(-17.9937 744.931 49.0422)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.791 53.1011L742.678 53.4623",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.958 59.7739L744.846 60.1351",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.824 52.0457L756.357 53.9372L759.721 49.1559",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.874 56.4374L742.65 57.1598",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2278,
    y: 206.97,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8893 210.478L37.72 210.478",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8893 217.494L37.72 217.494",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9049 211.647L50.5822 215.155L55.2595 211.647",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8889 213.986H36.5503",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.481,
    y: 206.968,
    width: 18.7092,
    height: 14.0319,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.142 210.476L515.973 210.476",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.142 217.492L515.973 217.492",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.158 211.646L528.836 215.153L533.513 211.646",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.142 213.984H514.804",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0688 43.2644H29.0271C26.3343 43.2644 24.5094 45.7844 25.1604 48.3973C25.8005 50.9668 25.7668 52.8903 24.037 56.5749L23.1033 57.2963L27.1959 56.127H33.0425L37.4026 56.807C35.7524 54.1233 35.6266 51.5229 36.1756 48.6963C36.7066 45.9621 34.8541 43.2644 32.0688 43.2644Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5344 43.1977V40.9259H31.873V43.2645",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4021 56.807C35.7519 54.1233 35.6261 51.5229 36.1751 48.6963C36.7061 45.9621 34.8536 43.2644 32.0683 43.2644H29.0266C26.3338 43.2644 24.5089 45.7844 25.1599 48.3973C25.8 50.9668 25.7663 52.8903 24.0365 56.5749",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.7036,
    cy: 57.8809,
    rx: 8.18526,
    ry: 1.75398,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0425 63.1428C33.0425 63.1428 32.6528 64.3121 30.7039 64.3121C28.755 64.3121 28.3652 63.1428 28.3652 63.1428",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.322 43.2626H507.28C504.588 43.2626 502.763 45.7825 503.414 48.3954C504.054 50.9649 504.02 52.8885 502.29 56.5731L501.357 57.2944L505.449 56.1251H511.296L515.656 56.8052C514.006 54.1215 513.88 51.5211 514.429 48.6945C514.96 45.9602 513.107 43.2626 510.322 43.2626Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.788 43.1959V40.9241H510.126V43.2627",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.655 56.8052C514.005 54.1215 513.879 51.5211 514.428 48.6945C514.96 45.9602 513.107 43.2626 510.322 43.2626H507.28C504.587 43.2626 502.762 45.7825 503.413 48.3954C504.053 50.9649 504.02 52.8885 502.29 56.5731",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.957,
    cy: 57.8793,
    rx: 8.18526,
    ry: 1.75398,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.296 63.1412C511.296 63.1412 510.906 64.3106 508.957 64.3106C507.008 64.3106 506.619 63.1412 506.619 63.1412",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1353 316.857L90.5996 315.177C88.3547 313.69 85.4417 314.783 84.5413 317.321C83.6559 319.816 82.5655 321.401 79.0885 323.518L77.9117 323.603L81.9693 324.889L86.8434 328.118L90.1026 331.093C90.2091 327.944 91.5403 325.707 93.5591 323.654C95.5119 321.667 95.4574 318.395 93.1353 316.857Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.059 315.402L92.3137 313.508L94.2633 314.799L92.9717 316.749",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1021 331.093C90.2085 327.944 91.5398 325.707 93.5585 323.653C95.5113 321.667 95.4568 318.395 93.1347 316.857L90.599 315.177C88.3541 313.69 85.4411 314.783 84.5407 317.321C83.6553 319.816 82.5649 321.401 79.0879 323.518",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.9243,
    cy: 328.289,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(33.5233 83.9243 328.289)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9686 333.967C82.9686 333.967 81.9979 334.726 80.3732 333.65C78.7485 332.574 79.0693 331.384 79.0693 331.384",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.389 316.855L568.853 315.175C566.608 313.688 563.695 314.781 562.795 317.319C561.909 319.815 560.819 321.4 557.342 323.516L556.165 323.602L560.223 324.887L565.097 328.116L568.356 331.091C568.463 327.942 569.794 325.705 571.812 323.652C573.765 321.666 573.711 318.394 571.389 316.855Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.313 315.4L570.568 313.506L572.517 314.798L571.226 316.747",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.356 331.091C568.462 327.942 569.794 325.705 571.812 323.652C573.765 321.665 573.711 318.393 571.389 316.855L568.853 315.175C566.608 313.688 563.695 314.781 562.795 317.319C561.909 319.815 560.819 321.4 557.342 323.516",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.178,
    cy: 328.287,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(33.5233 562.178 328.287)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.223 333.965C561.223 333.965 560.252 334.725 558.627 333.648C557.002 332.572 557.323 331.382 557.323 331.382",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.495 164.874H363.453C360.76 164.874 358.935 167.394 359.586 170.007C360.226 172.577 360.193 174.5 358.463 178.185L357.529 178.906L361.622 177.737H367.468L371.828 178.417C370.178 175.733 370.052 173.133 370.601 170.306C371.132 167.572 369.28 164.874 366.495 164.874Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.961 164.808V162.536H366.299V164.875",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.828 178.417C370.178 175.733 370.052 173.133 370.601 170.306C371.132 167.572 369.28 164.874 366.495 164.874H363.453C360.76 164.874 358.935 167.394 359.586 170.007C360.226 172.577 360.193 174.5 358.463 178.185",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.13,
    cy: 179.491,
    rx: 8.18526,
    ry: 1.75398,
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.468 184.753C367.468 184.753 367.079 185.922 365.13 185.922C363.181 185.922 362.791 184.753 362.791 184.753",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.064 204.724L261.5 203.088C259.23 201.639 256.336 202.782 255.479 205.334C254.637 207.845 253.573 209.448 250.133 211.623L248.958 211.729L253.037 212.945L257.965 216.091L261.274 219.01C261.327 215.86 262.62 213.6 264.604 211.513C266.522 209.494 266.412 206.223 264.064 204.724Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.964 203.305L263.186 201.39L265.157 202.648L263.899 204.619",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.274 219.01C261.327 215.86 262.62 213.6 264.604 211.513C266.522 209.494 266.412 206.223 264.064 204.724L261.5 203.088C259.23 201.639 256.336 202.782 255.479 205.334C254.636 207.845 253.573 209.448 250.133 211.623",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.05,
    cy: 216.311,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 255.05 216.311)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19 222.005C254.19 222.005 253.232 222.781 251.59 221.732C249.947 220.684 250.247 219.488 250.247 219.488",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.317 204.723L739.753 203.086C737.483 201.638 734.589 202.78 733.732 205.333C732.889 207.843 731.826 209.446 728.386 211.622L727.211 211.727L731.29 212.944L736.218 216.089L739.527 219.008C739.58 215.858 740.873 213.598 742.857 211.511C744.775 209.492 744.665 206.221 742.317 204.723Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.217 203.303L741.439 201.388L743.411 202.646L742.152 204.618",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.527 219.008C739.58 215.858 740.873 213.599 742.856 211.511C744.775 209.492 744.665 206.222 742.317 204.723L739.753 203.087C737.483 201.638 734.589 202.78 733.732 205.333C732.889 207.843 731.826 209.447 728.386 211.622",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.303,
    cy: 216.31,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 733.303 216.31)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.443 222.003C732.443 222.003 731.486 222.779 729.843 221.731C728.2 220.682 728.501 219.487 728.501 219.487",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.461 318.149L215.897 316.513C213.627 315.064 210.733 316.206 209.876 318.759C209.033 321.269 207.97 322.873 204.529 325.048L203.354 325.154L207.433 326.37L212.361 329.515L215.671 332.434C215.724 329.284 217.017 327.025 219 324.937C220.919 322.918 220.809 319.648 218.461 318.149Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36 316.729L217.583 314.814L219.554 316.072L218.296 318.044",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.671 332.434C215.723 329.284 217.016 327.025 219 324.937C220.919 322.918 220.808 319.648 218.461 318.149L215.897 316.513C213.627 315.064 210.733 316.206 209.876 318.759C209.033 321.269 207.97 322.873 204.529 325.048",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.446,
    cy: 329.736,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 209.446 329.736)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.586 335.429C208.586 335.429 207.629 336.205 205.986 335.157C204.343 334.108 204.644 332.913 204.644 332.913",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.715 318.147L694.151 316.51C691.881 315.062 688.987 316.204 688.13 318.757C687.287 321.267 686.224 322.87 682.783 325.046L681.608 325.151L685.687 326.368L690.615 329.513L693.925 332.432C693.978 329.282 695.271 327.022 697.254 324.935C699.173 322.916 699.063 319.645 696.715 318.147Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.614 316.727L695.837 314.812L697.808 316.07L696.55 318.042",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.925 332.432C693.977 329.282 695.27 327.022 697.254 324.935C699.172 322.916 699.062 319.645 696.714 318.147L694.15 316.51C691.881 315.062 688.987 316.204 688.13 318.757C687.287 321.267 686.223 322.87 682.783 325.046",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 687.7,
    cy: 329.734,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 687.7 329.734)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.841 335.427C686.841 335.427 685.883 336.203 684.24 335.155C682.598 334.106 682.898 332.911 682.898 332.911",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.128 333.35L289.564 331.714C287.294 330.265 284.4 331.407 283.543 333.96C282.7 336.47 281.637 338.074 278.197 340.249L277.021 340.355L281.1 341.571L286.029 344.716L289.338 347.635C289.391 344.485 290.684 342.226 292.667 340.138C294.586 338.119 294.476 334.849 292.128 333.35Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.028 331.93L291.25 330.015L293.221 331.274L291.963 333.245",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.338 347.635C289.391 344.485 290.684 342.226 292.667 340.138C294.586 338.119 294.476 334.849 292.128 333.35L289.564 331.714C287.294 330.265 284.4 331.407 283.543 333.96C282.7 336.47 281.637 338.074 278.196 340.249",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.113,
    cy: 344.937,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 283.113 344.937)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.254 350.631C282.254 350.631 281.297 351.407 279.654 350.358C278.011 349.31 278.312 348.114 278.312 348.114",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.096 420.018L353.317 421.254C350.856 422.348 350.213 425.393 351.87 427.515C353.499 429.603 354.25 431.374 354.167 435.444L353.607 436.482L356.871 433.751L362.213 431.374L366.473 430.224C363.875 428.442 362.703 426.118 362.056 423.312C361.43 420.598 358.641 418.886 356.096 420.018Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.753 420.987L352.83 418.911L354.967 417.96L355.917 420.097",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.473 430.224C363.875 428.443 362.703 426.118 362.056 423.312C361.43 420.598 358.641 418.886 356.096 420.018L353.317 421.254C350.856 422.349 350.213 425.393 351.87 427.516C353.499 429.603 354.25 431.374 354.167 435.444",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.79,
    cy: 433.928,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(-23.9803 360.79 433.928)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.065 437.785C365.065 437.785 365.184 439.011 363.404 439.803C361.623 440.596 360.792 439.686 360.792 439.686",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.575 499.392L265.011 497.756C262.741 496.307 259.847 497.45 258.99 500.002C258.147 502.513 257.084 504.116 253.643 506.291L252.468 506.397L256.547 507.613L261.476 510.759L264.785 513.678C264.838 510.528 266.131 508.268 268.114 506.181C270.033 504.161 269.923 500.891 267.575 499.392Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.825 499.394L743.261 497.757C740.991 496.308 738.097 497.451 737.24 500.003C736.397 502.514 735.334 504.117 731.893 506.292L730.718 506.398L734.797 507.614L739.726 510.76L743.035 513.679C743.088 510.529 744.381 508.269 746.364 506.182C748.283 504.163 748.173 500.892 745.825 499.394Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.474 497.972L266.696 496.057L268.667 497.316L267.409 499.287",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.724 497.974L744.946 496.059L746.918 497.317L745.66 499.288",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.784 513.677C264.837 510.527 266.13 508.267 268.114 506.18C270.032 504.161 269.922 500.89 267.574 499.392L265.01 497.755C262.74 496.307 259.846 497.449 258.989 500.002C258.146 502.512 257.083 504.116 253.643 506.291",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.034 513.679C743.087 510.529 744.38 508.269 746.364 506.182C748.282 504.163 748.172 500.892 745.824 499.393L743.26 497.757C740.99 496.308 738.096 497.451 737.239 500.003C736.397 502.514 735.333 504.117 731.893 506.292",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.56,
    cy: 510.979,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 258.56 510.979)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.81,
    cy: 510.98,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 736.81 510.98)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.701 516.672C257.701 516.672 256.743 517.448 255.1 516.4C253.457 515.351 253.758 514.156 253.758 514.156",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.702 480.843L108.927 482.089C106.471 483.193 105.84 486.24 107.504 488.356C109.141 490.438 109.899 492.206 109.832 496.276L109.276 497.317L112.529 494.572L117.862 492.176L122.118 491.009C119.513 489.238 118.332 486.917 117.674 484.114C117.038 481.402 114.243 479.701 111.702 480.843Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.363 481.82L108.431 479.748L110.565 478.79L111.523 480.923",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.118 491.009C119.512 489.238 118.332 486.917 117.674 484.114C117.037 481.402 114.242 479.701 111.701 480.843L108.927 482.089C106.471 483.193 105.839 486.24 107.504 488.356C109.141 490.438 109.899 492.206 109.831 496.276",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.448,
    cy: 494.734,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(-24.1978 116.448 494.734)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.738 498.576C120.738 498.576 120.862 499.802 119.084 500.601C117.306 501.399 116.472 500.493 116.472 500.493",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.955 480.841L587.181 482.088C584.725 483.192 584.093 486.238 585.758 488.355C587.395 490.436 588.153 492.204 588.085 496.274L587.529 497.315L590.783 494.571L596.116 492.174L600.371 491.007C597.766 489.236 596.585 486.916 595.928 484.112C595.291 481.401 592.496 479.699 589.955 480.841Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.616 481.819L586.685 479.747L588.818 478.788L589.777 480.921",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.371 491.007C597.766 489.236 596.585 486.916 595.927 484.112C595.291 481.401 592.495 479.699 589.955 480.841L587.18 482.088C584.724 483.191 584.093 486.238 585.757 488.354C587.394 490.436 588.152 492.204 588.085 496.274",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 594.701,
    cy: 494.733,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(-24.1978 594.701 494.733)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.991 498.574C598.991 498.574 599.115 499.8 597.338 500.599C595.56 501.398 594.725 500.491 594.725 500.491",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.3483 529.505L-13.1178 532.982C-14.6843 536.061 -12.8653 539.613 -9.49971 540.389C-6.19005 541.152 -4.01075 542.309 -0.805043 546.43L-0.523644 547.917L0.520537 542.558L3.92179 535.875L7.23567 531.286C3.20782 531.612 0.162042 530.243 -2.74976 527.971C-5.56648 525.773 -9.72793 526.321 -11.3483 529.505Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23471 531.287C3.20686 531.612 0.161083 530.243 -2.75072 527.971C-5.56744 525.773 -9.72889 526.322 -11.3493 529.506L-13.1188 532.983C-14.6853 536.061 -12.8662 539.613 -9.50067 540.389C-6.19101 541.152 -4.01171 542.309 -0.806001 546.43",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.56611,
    cy: 539.569,
    rx: 10.4988,
    ry: 2.24974,
    transform: "rotate(-63.0282 4.56611 539.569)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9422 539.956C11.9422 539.956 13.0521 541.082 11.9184 543.31C10.7846 545.538 9.22119 545.303 9.22119 545.303",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.201 537.692L522.432 541.169C520.865 544.247 522.684 547.799 526.05 548.575C529.36 549.338 531.539 550.495 534.745 554.616L535.026 556.103L536.07 550.745L539.471 544.061L542.785 539.473C538.758 539.798 535.712 538.429 532.8 536.157C529.983 533.959 525.822 534.508 524.201 537.692Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.65 540.55L520.053 539.228L521.414 536.555L524.087 537.915",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.785 539.473C538.757 539.798 535.711 538.429 532.799 536.157C529.982 533.96 525.821 534.508 524.201 537.692L522.431 541.169C520.865 544.247 522.684 547.799 526.049 548.575C529.359 549.338 531.538 550.496 534.744 554.617",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.116,
    cy: 547.755,
    rx: 10.4988,
    ry: 2.24974,
    transform: "rotate(-63.0282 540.116 547.755)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.492 548.142C547.492 548.142 548.602 549.268 547.468 551.496C546.334 553.724 544.771 553.489 544.771 553.489",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.572 592.662L367.833 590.627C369.834 588.825 369.504 585.731 367.272 584.225C365.077 582.744 363.815 581.291 362.636 577.396L362.847 576.235L360.588 579.842L356.243 583.754L352.547 586.165C355.569 587.056 357.402 588.904 358.885 591.372C360.32 593.76 363.502 594.525 365.572 592.662Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.547 586.165C355.569 587.056 357.402 588.904 358.885 591.372C360.32 593.76 363.501 594.525 365.572 592.662L367.832 590.627C369.834 588.825 369.504 585.731 367.272 584.225C365.077 582.743 363.815 581.291 362.636 577.395",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.807,
    cy: 580.885,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(138.007 356.807 580.885)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.549 578.539C351.549 578.539 351.056 577.409 352.504 576.105C353.953 574.801 355.025 575.41 355.025 575.41",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.17 463.681L436.141 463.966C433.46 464.218 431.88 466.898 432.773 469.438C433.651 471.936 433.797 473.855 432.42 477.685L431.558 478.491L435.523 476.943L441.344 476.395L445.749 476.664C443.854 474.147 443.486 471.57 443.767 468.704C444.04 465.932 441.943 463.42 439.17 463.681Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.641 463.852L436.428 461.59L438.756 461.371L438.975 463.699",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.749 476.664C443.854 474.147 443.485 471.57 443.767 468.704C444.039 465.932 441.942 463.42 439.169 463.681L436.141 463.966C433.46 464.218 431.879 466.898 432.772 469.439C433.65 471.937 433.797 473.855 432.42 477.686",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.181,
    cy: 478.361,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(-5.37644 439.181 478.361)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.002 483.381C442.002 483.381 441.724 484.581 439.783 484.764C437.843 484.947 437.345 483.819 437.345 483.819",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.997 343.874L378.433 342.237C376.163 340.789 373.269 341.931 372.412 344.484C371.569 346.994 370.506 348.597 367.065 350.773L365.89 350.878L369.969 352.095L374.898 355.24L378.207 358.159C378.26 355.009 379.553 352.749 381.536 350.662C383.455 348.643 383.345 345.372 380.997 343.874Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.896 342.454L380.118 340.539L382.09 341.797L380.832 343.769",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.206 358.159C378.259 355.009 379.552 352.749 381.536 350.662C383.454 348.643 383.344 345.372 380.996 343.874L378.432 342.237C376.162 340.789 373.268 341.931 372.411 344.484C371.568 346.994 370.505 348.597 367.065 350.773",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.982,
    cy: 355.461,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 371.982 355.461)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.122 361.154C371.122 361.154 370.165 361.93 368.522 360.882C366.879 359.833 367.18 358.638 367.18 358.638",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.309 257.344L442.745 255.707C440.476 254.259 437.582 255.401 436.724 257.954C435.882 260.464 434.818 262.067 431.378 264.243L430.203 264.348L434.282 265.565L439.21 268.71L442.519 271.629C442.572 268.479 443.865 266.219 445.849 264.132C447.767 262.113 447.657 258.842 445.309 257.344Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.209 255.924L444.431 254.009L446.403 255.267L445.145 257.239",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.519 271.629C442.572 268.479 443.865 266.219 445.849 264.132C447.767 262.113 447.657 258.842 445.309 257.344L442.745 255.707C440.475 254.259 437.581 255.401 436.724 257.954C435.882 260.464 434.818 262.067 431.378 264.243",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.295,
    cy: 268.931,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(32.5478 436.295 268.931)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.436 274.624C435.436 274.624 434.478 275.4 432.835 274.352C431.192 273.303 431.493 272.108 431.493 272.108",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.147 210.985L118.255 210.042C115.695 209.207 113.179 211.037 112.987 213.723C112.799 216.364 112.17 218.182 109.383 221.149L108.272 221.545L112.525 221.703L118.084 223.516L122.018 225.515C121.281 222.451 121.968 219.94 123.367 217.423C124.719 214.988 123.795 211.849 121.147 210.985Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.758 210.136L119.463 207.976L121.686 208.701L120.961 210.925",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.018 225.514C121.281 222.451 121.968 219.94 123.367 217.423C124.719 214.988 123.795 211.849 121.147 210.985L118.255 210.042C115.695 209.207 113.179 211.037 112.987 213.723C112.799 216.364 112.17 218.182 109.383 221.149",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.316,
    cy: 224.458,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(18.0666 115.316 224.458)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.908 230.186C115.908 230.186 115.175 231.176 113.322 230.572C111.47 229.968 111.462 228.735 111.462 228.735",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.4 210.984L596.508 210.04C593.948 209.205 591.432 211.035 591.24 213.721C591.052 216.362 590.423 218.181 587.636 221.147L586.525 221.543L590.778 221.701L596.336 223.514L600.271 225.513C599.534 222.45 600.221 219.938 601.619 217.421C602.972 214.987 602.048 211.848 599.4 210.984Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.011 210.135L597.716 207.975L599.939 208.7L599.214 210.923",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.271 225.513C599.535 222.45 600.221 219.938 601.62 217.421C602.973 214.987 602.048 211.847 599.4 210.984L596.508 210.04C593.948 209.205 591.432 211.035 591.241 213.721C591.052 216.362 590.424 218.181 587.637 221.147",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.57,
    cy: 224.457,
    rx: 8.18526,
    ry: 1.75398,
    transform: "rotate(18.0666 593.57 224.457)",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.161 230.184C594.161 230.184 593.428 231.175 591.575 230.57C589.722 229.966 589.714 228.734 589.714 228.734",
    stroke: "#FDDC9F",
    strokeWidth: 1.63705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47021 139.164L3.7146 150.869L6.0114 150.428L20.6294 145.58L20.6294 139.733L19.8733 135.791C19.8733 135.791 14.2453 136.714 10.6574 137.402L1.47021 139.164Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0114 150.428L3.7146 150.869L1.47021 139.164C1.47021 139.164 7.06959 138.09 10.6574 137.402C14.2453 136.714 19.8733 135.791 19.8733 135.791C19.8733 135.791 20.2542 137.777 20.6294 139.733",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14795 143.592V152.011C6.14795 153.303 7.195 154.35 8.48659 154.35H9.65592V155.236C9.65592 156.2 9.7373 157.626 10.7012 157.599C11.3551 157.581 11.5888 156.782 11.9445 156.233L13.1639 154.35H21.583C23.3912 154.35 24.8571 152.884 24.8571 151.076V143.67C24.8571 141.902 23.7014 140.361 21.9338 140.318C20.0293 140.272 17.3738 140.318 15.5025 140.318H9.42157C7.61333 140.318 6.14795 141.784 6.14795 143.592Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8251,
    cy: 147.334,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5026,
    cy: 147.334,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1797,
    cy: 147.334,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.724 139.163L481.968 150.867L484.265 150.427L498.883 145.579L498.883 139.732L498.127 135.789C498.127 135.789 492.499 136.713 488.911 137.401L479.724 139.163Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.265 150.427L481.968 150.867L479.724 139.163C479.724 139.163 485.323 138.089 488.911 137.401C492.499 136.713 498.127 135.789 498.127 135.789C498.127 135.789 498.508 137.775 498.883 139.732",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.401 143.591V152.01C484.401 153.302 485.448 154.349 486.74 154.349H487.909V155.234C487.909 156.199 487.991 157.625 488.954 157.598C489.608 157.58 489.842 156.78 490.198 156.231L491.417 154.349H499.836C501.645 154.349 503.11 152.883 503.11 151.075V143.669C503.11 141.901 501.955 140.359 500.187 140.317C498.283 140.271 495.627 140.317 493.756 140.317H487.675C485.867 140.317 484.401 141.783 484.401 143.591Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.078,
    cy: 147.333,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.755,
    cy: 147.333,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.433,
    cy: 147.333,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1379 275.975L77.3823 287.68L79.6791 287.239L94.2971 282.391L94.2971 276.544L93.5411 272.602C93.5411 272.602 87.913 273.525 84.3251 274.213L75.1379 275.975Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6791 287.239L77.3823 287.68L75.1379 275.975C75.1379 275.975 80.7373 274.901 84.3251 274.213C87.913 273.525 93.5411 272.602 93.5411 272.602C93.5411 272.602 93.9219 274.588 94.2971 276.544",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8149 280.403V288.822C79.8149 290.114 80.862 291.161 82.1536 291.161H83.3229V292.047C83.3229 293.011 83.4043 294.437 84.3682 294.41C85.0221 294.392 85.2558 293.593 85.6115 293.044L86.8309 291.161H95.25C97.0582 291.161 98.5241 289.695 98.5241 287.887V280.481C98.5241 278.713 97.3684 277.172 95.6008 277.129C93.6962 277.083 91.0408 277.129 89.1695 277.129H83.0886C81.2803 277.129 79.8149 278.595 79.8149 280.403Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.4921,
    cy: 284.145,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.1697,
    cy: 284.145,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.8468,
    cy: 284.145,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.392 275.974L555.636 287.678L557.933 287.238L572.551 282.39L572.551 276.543L571.795 272.6C571.795 272.6 566.167 273.524 562.579 274.212L553.392 275.974Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.933 287.238L555.636 287.678L553.392 275.974C553.392 275.974 558.991 274.9 562.579 274.212C566.167 273.524 571.795 272.6 571.795 272.6C571.795 272.6 572.176 274.586 572.551 276.543",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.069 280.402V288.821C558.069 290.112 559.116 291.159 560.407 291.159H561.577V292.045C561.577 293.009 561.658 294.436 562.622 294.409C563.276 294.391 563.51 293.591 563.865 293.042L565.085 291.159H573.504C575.312 291.159 576.778 289.694 576.778 287.886V280.48C576.778 278.711 575.622 277.17 573.855 277.128C571.95 277.082 569.295 277.128 567.423 277.128H561.342C559.534 277.128 558.069 278.593 558.069 280.402Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.746,
    cy: 284.143,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.423,
    cy: 284.143,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.101,
    cy: 284.143,
    r: 1.16932,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.795 83.1888L200.434 94.6231L202.678 95.2826L217.894 97.6616L220.569 92.4631L221.702 88.6114C221.702 88.6114 216.275 86.8572 212.77 85.8269L203.795 83.1888Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.678 95.2829L200.434 94.6233L203.795 83.1891C203.795 83.1891 209.265 84.7969 212.77 85.8272C216.275 86.8574 221.702 88.6116 221.702 88.6116C221.702 88.6116 221.131 90.5519 220.569 92.4633",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.927 89.2667L202.074 96.7524C201.483 97.9008 201.934 99.311 203.083 99.9021L204.123 100.437L203.717 101.225C203.276 102.082 202.696 103.388 203.565 103.805C204.155 104.088 204.728 103.484 205.296 103.158L207.242 102.043L214.727 105.896C216.335 106.723 218.309 106.091 219.137 104.483L222.526 97.898C223.335 96.3259 223.013 94.4267 221.461 93.5798C219.789 92.6674 217.406 91.493 215.743 90.6366L210.336 87.8537C208.728 87.0262 206.754 87.6589 205.927 89.2667Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.373,
    cy: 94.7341,
    r: 1.16932,
    transform: "rotate(27.235 208.373 94.7341)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.532,
    cy: 96.8746,
    r: 1.16932,
    transform: "rotate(27.235 212.532 96.8746)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.691,
    cy: 99.0153,
    r: 1.16932,
    transform: "rotate(27.235 216.691 99.0153)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.048 83.187L678.687 94.6213L680.931 95.2808L696.147 97.6598L698.823 92.4613L699.955 88.6095C699.955 88.6095 694.528 86.8554 691.023 85.8251L682.048 83.187Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.931 95.281L678.687 94.6215L682.048 83.1873C682.048 83.1873 687.518 84.7951 691.023 85.8254C694.528 86.8556 699.955 88.6098 699.955 88.6098C699.955 88.6098 699.385 90.5501 698.823 92.4615",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.181 89.2649L680.328 96.7506C679.736 97.899 680.188 99.3092 681.337 99.9002L682.376 100.435L681.971 101.223C681.53 102.08 680.949 103.386 681.819 103.803C682.408 104.086 682.982 103.482 683.55 103.157L685.495 102.041L692.981 105.894C694.589 106.721 696.563 106.089 697.391 104.481L700.78 97.8962C701.589 96.3241 701.267 94.4248 699.715 93.578C698.042 92.6655 695.66 91.4912 693.996 90.6348L688.59 87.8519C686.982 87.0244 685.008 87.6571 684.181 89.2649Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.627,
    cy: 94.7325,
    r: 1.16932,
    transform: "rotate(27.235 686.627 94.7325)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690.786,
    cy: 96.873,
    r: 1.16932,
    transform: "rotate(27.235 690.786 96.873)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.944,
    cy: 99.0137,
    r: 1.16932,
    transform: "rotate(27.235 694.944 99.0137)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6649 11.3175L46.3039 22.7518L48.5476 23.4113L63.7638 25.7902L66.4395 20.5918L67.5717 16.74C67.5717 16.74 62.1447 14.9859 58.6398 13.9556L49.6649 11.3175Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5476 23.4115L46.3039 22.752L49.6649 11.3177C49.6649 11.3177 55.1349 12.9256 58.6398 13.9559C62.1447 14.9861 67.5717 16.7403 67.5717 16.7403C67.5717 16.7403 67.0013 18.6806 66.4395 20.592",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7972 17.3952L47.9443 24.881C47.3532 26.0294 47.805 27.4395 48.9534 28.0306L49.9931 28.5657L49.5878 29.3532C49.1465 30.2106 48.566 31.5162 49.4354 31.9333C50.0252 32.2163 50.5988 31.6125 51.1663 31.287L53.1121 30.1711L60.5979 34.0241C62.2057 34.8516 64.1797 34.2193 65.0073 32.6116L68.3966 26.0266C69.2057 24.4545 68.8835 22.5552 67.3314 21.7084C65.659 20.7959 63.2769 19.6215 61.6131 18.7652L56.2063 15.9822C54.5985 15.1547 52.6247 15.7875 51.7972 17.3952Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.243,
    cy: 22.863,
    r: 1.16932,
    transform: "rotate(27.235 54.243 22.863)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.402,
    cy: 25.0035,
    r: 1.16932,
    transform: "rotate(27.235 58.402 25.0035)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5611,
    cy: 27.1442,
    r: 1.16932,
    transform: "rotate(27.235 62.5611 27.1442)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.918 11.3156L524.557 22.7498L526.801 23.4093L542.017 25.7883L544.693 20.5898L545.825 16.7381C545.825 16.7381 540.398 14.9839 536.893 13.9537L527.918 11.3156Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.801 23.4096L524.557 22.75L527.918 11.3158C527.918 11.3158 533.388 12.9237 536.893 13.9539C540.398 14.9841 545.825 16.7383 545.825 16.7383C545.825 16.7383 545.255 18.6786 544.693 20.5901",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.05 17.3934L526.197 24.8791C525.606 26.0276 526.058 27.4377 527.206 28.0288L528.246 28.5639L527.841 29.3514C527.399 30.2088 526.819 31.5143 527.688 31.9315C528.278 32.2144 528.852 31.6106 529.419 31.2852L531.365 30.1693L538.851 34.0223C540.458 34.8498 542.433 34.2175 543.26 32.6097L546.649 26.0247C547.459 24.4527 547.136 22.5534 545.584 21.7065C543.912 20.7941 541.53 19.6197 539.866 18.7633L534.459 15.9804C532.851 15.1529 530.878 15.7856 530.05 17.3934Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.496,
    cy: 22.8611,
    r: 1.16932,
    transform: "rotate(27.235 532.496 22.8611)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 536.655,
    cy: 25.0017,
    r: 1.16932,
    transform: "rotate(27.235 536.655 25.0017)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.814,
    cy: 27.1422,
    r: 1.16932,
    transform: "rotate(27.235 540.814 27.1422)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.891 230.281L337.674 241.869L339.948 241.323L354.326 235.803L354.056 229.963L353.118 226.059C353.118 226.059 347.539 227.242 343.986 228.096L334.891 230.281Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.948 241.323L337.674 241.869L334.891 230.281C334.891 230.281 340.434 228.949 343.986 228.096C347.539 227.243 353.118 226.059 353.118 226.059C353.118 226.059 353.59 228.026 354.056 229.963",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.768 234.488L340.157 242.898C340.217 244.188 341.312 245.185 342.602 245.126L343.77 245.072L343.811 245.956C343.855 246.92 344.003 248.341 344.964 248.269C345.617 248.221 345.813 247.411 346.143 246.846L347.274 244.909L355.684 244.52C357.49 244.436 358.887 242.904 358.803 241.098L358.461 233.7C358.379 231.933 357.153 230.447 355.385 230.487C353.481 230.529 350.83 230.698 348.961 230.784L342.886 231.066C341.08 231.149 339.684 232.681 339.768 234.488Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.613,
    cy: 238.009,
    r: 1.16932,
    transform: "rotate(-2.65229 344.613 238.009)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.286,
    cy: 237.793,
    r: 1.16932,
    transform: "rotate(-2.65229 349.286 237.793)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.958,
    cy: 237.576,
    r: 1.16932,
    transform: "rotate(-2.65229 353.958 237.576)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.895 313.975L390.368 325.359L392.602 326.051L407.782 328.651L410.533 323.492L411.721 319.657C411.721 319.657 406.32 317.824 402.83 316.743L393.895 313.975Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.602 326.051L390.368 325.359L393.895 313.975C393.895 313.975 399.341 315.662 402.83 316.743C406.32 317.824 411.721 319.657 411.721 319.657C411.721 319.657 411.122 321.589 410.533 323.492",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.939 320.083L391.978 327.512C391.37 328.651 391.801 330.068 392.941 330.676L393.972 331.226L393.556 332.007C393.102 332.858 392.503 334.155 393.366 334.585C393.951 334.877 394.534 334.281 395.106 333.964L397.068 332.877L404.497 336.838C406.092 337.689 408.075 337.086 408.926 335.49L412.411 328.955C413.243 327.395 412.948 325.491 411.409 324.622C409.75 323.685 407.385 322.476 405.734 321.596L400.368 318.734C398.773 317.883 396.79 318.487 395.939 320.083Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.305,
    cy: 325.586,
    r: 1.16932,
    transform: "rotate(28.0694 398.305 325.586)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.432,
    cy: 327.786,
    r: 1.16932,
    transform: "rotate(28.0694 402.432 327.786)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.56,
    cy: 329.987,
    r: 1.16932,
    transform: "rotate(28.0694 406.56 329.987)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.144 393.986L228.928 405.574L231.202 405.028L245.58 399.508L245.309 393.668L244.371 389.764C244.371 389.764 238.792 390.947 235.24 391.801L226.144 393.986Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.202 405.028L228.928 405.574L226.144 393.986C226.144 393.986 231.688 392.654 235.24 391.801C238.792 390.948 244.371 389.764 244.371 389.764C244.371 389.764 244.844 391.731 245.309 393.668",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.021 398.193L231.411 406.603C231.47 407.893 232.565 408.89 233.855 408.831L235.023 408.777L235.064 409.661C235.109 410.624 235.256 412.046 236.218 411.974C236.87 411.926 237.066 411.116 237.396 410.551L238.527 408.614L246.937 408.225C248.744 408.141 250.14 406.609 250.057 404.803L249.714 397.405C249.632 395.638 248.406 394.152 246.639 394.192C244.734 394.234 242.083 394.403 240.214 394.489L234.14 394.771C232.333 394.854 230.937 396.386 231.021 398.193Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.867,
    cy: 401.714,
    r: 1.16932,
    transform: "rotate(-2.65229 235.867 401.714)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.539,
    cy: 401.498,
    r: 1.16932,
    transform: "rotate(-2.65229 240.539 401.498)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.211,
    cy: 401.281,
    r: 1.16932,
    transform: "rotate(-2.65229 245.211 401.281)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.397 393.984L707.18 405.572L709.454 405.026L723.832 399.506L723.562 393.666L722.624 389.762C722.624 389.762 717.045 390.945 713.493 391.799L704.397 393.984Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.454 405.026L707.18 405.572L704.397 393.984C704.397 393.984 709.941 392.652 713.493 391.799C717.045 390.946 722.624 389.762 722.624 389.762C722.624 389.762 723.097 391.729 723.562 393.666",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.274 398.191L709.664 406.601C709.723 407.891 710.818 408.889 712.108 408.829L713.276 408.775L713.317 409.66C713.362 410.623 713.509 412.044 714.471 411.972C715.123 411.924 715.319 411.114 715.649 410.55L716.78 408.612L725.19 408.223C726.997 408.139 728.393 406.607 728.309 404.801L727.967 397.403C727.885 395.637 726.659 394.151 724.891 394.19C722.987 394.232 720.336 394.401 718.467 394.487L712.393 394.769C710.586 394.852 709.19 396.385 709.274 398.191Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.12,
    cy: 401.712,
    r: 1.16932,
    transform: "rotate(-2.65229 714.12 401.712)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 718.792,
    cy: 401.496,
    r: 1.16932,
    transform: "rotate(-2.65229 718.792 401.496)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 723.464,
    cy: 401.279,
    r: 1.16932,
    transform: "rotate(-2.65229 723.464 401.279)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.684 270.038L246.467 281.626L248.741 281.08L263.119 275.56L262.849 269.72L261.911 265.816C261.911 265.816 256.332 266.999 252.779 267.853L243.684 270.038Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.741 281.08L246.467 281.626L243.684 270.038C243.684 270.038 249.227 268.706 252.779 267.853C256.332 267 261.911 265.816 261.911 265.816C261.911 265.816 262.383 267.783 262.849 269.72",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.561 274.245L248.95 282.655C249.01 283.945 250.105 284.942 251.395 284.883L252.563 284.829L252.604 285.713C252.648 286.676 252.796 288.098 253.757 288.026C254.41 287.978 254.606 287.168 254.936 286.603L256.067 284.666L264.477 284.277C266.283 284.193 267.68 282.661 267.596 280.855L267.254 273.457C267.172 271.69 265.946 270.204 264.178 270.244C262.274 270.286 259.623 270.455 257.754 270.541L251.679 270.823C249.873 270.906 248.477 272.438 248.561 274.245Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.406,
    cy: 277.766,
    r: 1.16932,
    transform: "rotate(-2.65229 253.406 277.766)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.078,
    cy: 277.55,
    r: 1.16932,
    transform: "rotate(-2.65229 258.078 277.55)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.751,
    cy: 277.333,
    r: 1.16932,
    transform: "rotate(-2.65229 262.751 277.333)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.937 270.036L724.72 281.624L726.994 281.078L741.372 275.558L741.102 269.718L740.164 265.814C740.164 265.814 734.585 266.997 731.032 267.851L721.937 270.036Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.994 281.078L724.72 281.624L721.937 270.036C721.937 270.036 727.48 268.704 731.032 267.851C734.585 266.998 740.164 265.814 740.164 265.814C740.164 265.814 740.636 267.781 741.102 269.718",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.814 274.243L727.203 282.653C727.263 283.943 728.357 284.941 729.648 284.881L730.816 284.827L730.857 285.711C730.901 286.675 731.049 288.096 732.01 288.024C732.662 287.976 732.859 287.166 733.189 286.601L734.32 284.664L742.73 284.275C744.536 284.191 745.933 282.659 745.849 280.853L745.506 273.455C745.424 271.689 744.199 270.202 742.431 270.242C740.526 270.284 737.876 270.453 736.007 270.539L729.932 270.821C728.126 270.904 726.73 272.436 726.814 274.243Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731.659,
    cy: 277.764,
    r: 1.16932,
    transform: "rotate(-2.65229 731.659 277.764)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 736.332,
    cy: 277.548,
    r: 1.16932,
    transform: "rotate(-2.65229 736.332 277.548)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741.004,
    cy: 277.331,
    r: 1.16932,
    transform: "rotate(-2.65229 741.004 277.331)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.964 430.674L97.4546 440.657L99.4137 441.934L113.302 448.591L117.36 444.382L119.553 441.019C119.553 441.019 114.86 437.778 111.8 435.782L103.964 430.674Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4137 441.935L97.4546 440.657L103.964 430.674C103.964 430.674 108.74 433.788 111.8 435.783C114.86 437.778 119.553 441.019 119.553 441.019C119.553 441.019 118.448 442.713 117.36 444.382",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.257 437.108L98.413 443.168C97.5165 444.098 97.5435 445.579 98.4732 446.475L99.315 447.287L98.7002 447.924C98.0309 448.618 97.0993 449.702 97.8119 450.351C98.2953 450.792 99.0185 450.379 99.6556 450.23L101.84 449.722L107.901 455.566C109.202 456.821 111.275 456.783 112.53 455.481L117.671 450.15C118.898 448.877 119.136 446.966 117.893 445.708C116.554 444.353 114.611 442.543 113.264 441.244L108.886 437.023C107.584 435.768 105.512 435.806 104.257 437.108Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.026,
    cy: 443.048,
    r: 1.16932,
    transform: "rotate(43.9571 105.026 443.048)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.393,
    cy: 446.295,
    r: 1.16932,
    transform: "rotate(43.9571 108.393 446.295)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.76,
    cy: 449.541,
    r: 1.16932,
    transform: "rotate(43.9571 111.76 449.541)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.217 430.672L575.708 440.656L577.667 441.933L591.555 448.589L595.614 444.38L597.806 441.017C597.806 441.017 593.114 437.776 590.053 435.781L582.217 430.672Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.667 441.933L575.708 440.656L582.217 430.672C582.217 430.672 586.993 433.786 590.053 435.781C593.114 437.776 597.806 441.018 597.806 441.018C597.806 441.018 596.702 442.712 595.614 444.381",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.51 437.106L576.666 443.167C575.77 444.097 575.797 445.577 576.727 446.474L577.568 447.285L576.954 447.923C576.284 448.617 575.353 449.7 576.065 450.35C576.549 450.791 577.272 450.377 577.909 450.229L580.094 449.72L586.154 455.564C587.456 456.819 589.528 456.782 590.784 455.48L595.924 450.149C597.152 448.876 597.389 446.964 596.147 445.707C594.807 444.352 592.864 442.541 591.517 441.243L587.139 437.022C585.838 435.766 583.765 435.805 582.51 437.106Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.28,
    cy: 443.046,
    r: 1.16932,
    transform: "rotate(43.9571 583.28 443.046)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.647,
    cy: 446.293,
    r: 1.16932,
    transform: "rotate(43.9571 586.647 446.293)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.014,
    cy: 449.54,
    r: 1.16932,
    transform: "rotate(43.9571 590.014 449.54)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.546 536.643L259.33 548.231L261.604 547.685L275.982 542.166L275.711 536.325L274.774 532.422C274.774 532.422 269.194 533.605 265.642 534.458L256.546 536.643Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.604 547.685L259.33 548.232L256.546 536.643C256.546 536.643 262.09 535.312 265.642 534.458C269.194 533.605 274.774 532.422 274.774 532.422C274.774 532.422 275.246 534.388 275.711 536.325",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.424 540.85L261.813 549.26C261.873 550.55 262.967 551.548 264.258 551.488L265.426 551.434L265.467 552.319C265.511 553.282 265.659 554.703 266.62 554.632C267.272 554.583 267.469 553.774 267.799 553.209L268.93 551.272L277.34 550.882C279.146 550.798 280.543 549.267 280.459 547.46L280.116 540.062C280.034 538.296 278.809 536.81 277.041 536.849C275.136 536.891 272.486 537.06 270.617 537.147L264.542 537.428C262.736 537.512 261.34 539.044 261.424 540.85Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.269,
    cy: 544.372,
    r: 1.16932,
    transform: "rotate(-2.65229 266.269 544.372)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.941,
    cy: 544.155,
    r: 1.16932,
    transform: "rotate(-2.65229 270.941 544.155)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.614,
    cy: 543.939,
    r: 1.16932,
    transform: "rotate(-2.65229 275.614 543.939)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.138 541.728L739.922 553.317L742.196 552.77L756.573 547.251L756.303 541.41L755.365 537.507C755.365 537.507 749.786 538.69 746.234 539.543L737.138 541.728Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.196 552.771L739.922 553.317L737.138 541.729C737.138 541.729 742.682 540.397 746.234 539.544C749.786 538.69 755.365 537.507 755.365 537.507C755.365 537.507 755.838 539.473 756.303 541.411",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.015 545.935L742.405 554.345C742.464 555.636 743.559 556.633 744.849 556.573L746.017 556.519L746.058 557.404C746.103 558.367 746.25 559.788 747.212 559.717C747.864 559.668 748.06 558.859 748.39 558.294L749.521 556.357L757.931 555.967C759.738 555.884 761.134 554.352 761.05 552.545L760.708 545.147C760.626 543.381 759.4 541.895 757.632 541.934C755.728 541.976 753.077 542.145 751.208 542.232L745.134 542.513C743.327 542.597 741.931 544.129 742.015 545.935Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746.86,
    cy: 549.457,
    r: 1.16932,
    transform: "rotate(-2.65229 746.86 549.457)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.532,
    cy: 549.241,
    r: 1.16932,
    transform: "rotate(-2.65229 751.532 549.241)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06 472.33L338.843 483.919L341.117 483.372L355.495 477.853L355.225 472.012L354.287 468.109C354.287 468.109 348.708 469.292 345.156 470.145L336.06 472.33Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.117 483.373L338.843 483.919L336.06 472.331C336.06 472.331 341.604 470.999 345.156 470.146C348.708 469.293 354.287 468.109 354.287 468.109C354.287 468.109 354.759 470.076 355.225 472.013",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.937 476.538L341.326 484.948C341.386 486.238 342.481 487.235 343.771 487.176L344.939 487.121L344.98 488.006C345.025 488.969 345.172 490.391 346.133 490.319C346.786 490.271 346.982 489.461 347.312 488.896L348.443 486.959L356.853 486.57C358.66 486.486 360.056 484.954 359.972 483.148L359.63 475.75C359.548 473.983 358.322 472.497 356.554 472.536C354.65 472.579 351.999 472.748 350.13 472.834L344.055 473.115C342.249 473.199 340.853 474.731 340.937 476.538Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.782,
    cy: 480.059,
    r: 1.16932,
    transform: "rotate(-2.65229 345.782 480.059)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.455,
    cy: 479.843,
    r: 1.16932,
    transform: "rotate(-2.65229 350.455 479.843)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.127,
    cy: 479.626,
    r: 1.16932,
    transform: "rotate(-2.65229 355.127 479.626)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34 203.58L207.545 214.301L209.649 213.28L222.508 204.803L220.99 199.157L219.236 195.546C219.236 195.546 214.041 197.899 210.755 199.494L202.34 203.58Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.649 213.28L207.545 214.301L202.34 203.58C202.34 203.58 207.468 201.09 210.755 199.494C214.041 197.899 219.236 195.546 219.236 195.546C219.236 195.546 220.12 197.365 220.99 199.157",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.006 206.643L210.191 214.773C210.526 216.021 211.809 216.76 213.057 216.425L214.186 216.121L214.416 216.976C214.666 217.908 215.115 219.264 216.039 218.988C216.665 218.8 216.684 217.968 216.885 217.345L217.574 215.211L225.704 213.025C227.45 212.556 228.486 210.76 228.016 209.014L226.094 201.862C225.635 200.154 224.119 198.966 222.401 199.383C220.549 199.833 217.997 200.567 216.19 201.053L210.317 202.631C208.571 203.1 207.536 204.896 208.006 206.643Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.494,
    cy: 209.042,
    r: 1.16932,
    transform: "rotate(-15.0444 213.494 209.042)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.011,
    cy: 207.828,
    r: 1.16932,
    transform: "rotate(-15.0444 218.011 207.828)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.528,
    cy: 206.614,
    r: 1.16932,
    transform: "rotate(-15.0444 222.528 206.614)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.593 203.579L685.798 214.3L687.902 213.278L700.76 204.802L699.243 199.155L697.489 195.544C697.489 195.544 692.294 197.897 689.008 199.493L680.593 203.579Z",
    fill: "#FFF8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.902 213.278L685.798 214.3L680.593 203.579C680.593 203.579 685.721 201.088 689.008 199.493C692.294 197.897 697.489 195.544 697.489 195.544C697.489 195.544 698.373 197.363 699.243 199.155",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.259 206.641L688.444 214.771C688.78 216.019 690.062 216.758 691.31 216.423L692.439 216.119L692.669 216.975C692.919 217.906 693.368 219.262 694.292 218.986C694.919 218.799 694.937 217.966 695.138 217.343L695.827 215.209L703.957 213.023C705.704 212.554 706.739 210.758 706.269 209.012L704.347 201.86C703.888 200.152 702.372 198.964 700.654 199.381C698.803 199.831 696.25 200.565 694.443 201.051L688.571 202.629C686.824 203.099 685.79 204.895 686.259 206.641Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.747,
    cy: 209.04,
    r: 1.16932,
    transform: "rotate(-15.0444 691.747 209.04)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.264,
    cy: 207.826,
    r: 1.16932,
    transform: "rotate(-15.0444 696.264 207.826)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.781,
    cy: 206.612,
    r: 1.16932,
    transform: "rotate(-15.0444 700.781 206.612)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.614 52.9991V62.9968C64.614 64.5306 65.8574 65.7739 67.3912 65.7739H68.7797V66.8257C68.7797 67.9707 68.8764 69.6647 70.021 69.6326C70.7975 69.6109 71.0751 68.6616 71.4974 68.0096L72.9454 65.7739H82.9431C85.0904 65.7739 86.8311 64.0335 86.8311 61.8862V52.9988C86.8311 50.8515 85.091 49.1111 82.9437 49.1111H68.5014C66.3542 49.1111 64.614 50.8518 64.614 52.9991Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.168,
    cy: 57.4428,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.7222,
    cy: 57.4428,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.2764,
    cy: 57.4428,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.868 52.9974V62.9951C542.868 64.5289 544.111 65.7722 545.645 65.7722H547.033V66.824C547.033 67.969 547.13 69.663 548.275 69.6309C549.051 69.6092 549.329 68.6599 549.751 68.0079L551.199 65.7722H561.197C563.344 65.7722 565.085 64.0318 565.085 61.8845V52.9971C565.085 50.8498 563.345 49.1094 561.197 49.1094H546.755C544.608 49.1094 542.868 50.8501 542.868 52.9974Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.422,
    cy: 57.4409,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 553.976,
    cy: 57.4409,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.53,
    cy: 57.4409,
    r: 1.38857,
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.119 116.088L319.459 125.947C319.204 127.46 320.224 128.892 321.736 129.147L323.105 129.378L322.931 130.415C322.741 131.544 322.555 133.23 323.689 133.389C324.458 133.496 324.889 132.606 325.414 132.033L327.213 130.069L337.072 131.729C339.19 132.086 341.195 130.659 341.552 128.541L343.027 119.777C343.384 117.659 341.957 115.654 339.84 115.298L325.598 112.9C323.48 112.543 321.475 113.971 321.119 116.088Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.858,
    cy: 121.392,
    r: 1.38857,
    transform: "rotate(9.55776 325.858 121.392)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.336,
    cy: 122.315,
    r: 1.38857,
    transform: "rotate(9.55776 331.336 122.315)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.813,
    cy: 123.237,
    r: 1.38857,
    transform: "rotate(9.55776 336.813 123.237)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.438 -3.37356L756.644 6.09627C757.135 7.54906 758.712 8.3281 760.164 7.83631L761.48 7.39108L761.817 8.38729C762.184 9.47188 762.819 11.0454 763.893 10.648C764.621 10.3785 764.58 9.39031 764.771 8.63732L765.426 6.05537L774.895 2.84968C776.929 2.16117 778.02 -0.0454869 777.331 -2.07939L774.482 -10.4976C773.793 -12.5315 771.587 -13.6221 769.553 -12.9336L755.873 -8.30275C753.839 -7.61424 752.749 -5.40747 753.438 -3.37356Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.599 277.455L163.939 287.314C163.684 288.827 164.704 290.259 166.216 290.514L167.586 290.745L167.411 291.782C167.221 292.911 167.035 294.597 168.169 294.756C168.938 294.863 169.37 293.973 169.894 293.401L171.694 291.436L181.552 293.096C183.67 293.453 185.675 292.026 186.032 289.908L187.508 281.144C187.864 279.027 186.437 277.021 184.32 276.665L170.078 274.267C167.96 273.91 165.955 275.338 165.599 277.455Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.338,
    cy: 282.759,
    r: 1.38857,
    transform: "rotate(9.55776 170.338 282.759)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.816,
    cy: 283.682,
    r: 1.38857,
    transform: "rotate(9.55776 175.816 283.682)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.293,
    cy: 284.604,
    r: 1.38857,
    transform: "rotate(9.55776 181.293 284.604)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.852 277.453L642.192 287.312C641.937 288.825 642.957 290.257 644.469 290.512L645.839 290.743L645.664 291.78C645.474 292.909 645.288 294.595 646.422 294.754C647.191 294.861 647.623 293.971 648.147 293.398L649.947 291.434L659.806 293.094C661.923 293.451 663.929 292.024 664.285 289.906L665.761 281.142C666.117 279.025 664.69 277.019 662.573 276.663L648.331 274.265C646.214 273.908 644.209 275.336 643.852 277.453Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.592,
    cy: 282.757,
    r: 1.38857,
    transform: "rotate(9.55776 648.592 282.757)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 654.069,
    cy: 283.68,
    r: 1.38857,
    transform: "rotate(9.55776 654.069 283.68)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.546,
    cy: 284.602,
    r: 1.38857,
    transform: "rotate(9.55776 659.546 284.602)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.808 250.561L476.148 260.42C475.894 261.933 476.913 263.365 478.426 263.62L479.795 263.851L479.62 264.888C479.43 266.017 479.244 267.703 480.378 267.862C481.148 267.969 481.579 267.079 482.104 266.506L483.903 264.542L493.762 266.202C495.879 266.559 497.885 265.132 498.241 263.014L499.717 254.25C500.074 252.133 498.647 250.127 496.529 249.771L482.287 247.373C480.17 247.016 478.165 248.444 477.808 250.561Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.548,
    cy: 255.865,
    r: 1.38857,
    transform: "rotate(9.55776 482.548 255.865)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.025,
    cy: 256.788,
    r: 1.38857,
    transform: "rotate(9.55776 488.025 256.788)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.502,
    cy: 257.71,
    r: 1.38857,
    transform: "rotate(9.55776 493.502 257.71)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.212 359.308L140.552 369.167C140.298 370.68 141.317 372.112 142.83 372.367L144.199 372.597L144.025 373.634C143.834 374.764 143.648 376.45 144.782 376.609C145.552 376.716 145.983 375.826 146.508 375.253L148.307 373.289L158.166 374.949C160.283 375.306 162.289 373.878 162.646 371.761L164.121 362.997C164.478 360.879 163.051 358.874 160.933 358.518L146.691 356.12C144.574 355.763 142.569 357.191 142.212 359.308Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.952,
    cy: 364.612,
    r: 1.38857,
    transform: "rotate(9.55776 146.952 364.612)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.43,
    cy: 365.534,
    r: 1.38857,
    transform: "rotate(9.55776 152.43 365.534)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.907,
    cy: 366.457,
    r: 1.38857,
    transform: "rotate(9.55776 157.907 366.457)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.466 359.306L618.806 369.165C618.551 370.678 619.571 372.11 621.083 372.365L622.452 372.596L622.278 373.633C622.088 374.762 621.902 376.448 623.036 376.607C623.805 376.714 624.236 375.824 624.761 375.251L626.56 373.287L636.419 374.947C638.537 375.304 640.542 373.877 640.899 371.759L642.374 362.995C642.731 360.878 641.304 358.872 639.186 358.516L624.945 356.118C622.827 355.761 620.822 357.189 620.466 359.306Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 625.205,
    cy: 364.61,
    r: 1.38857,
    transform: "rotate(9.55776 625.205 364.61)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.682,
    cy: 365.533,
    r: 1.38857,
    transform: "rotate(9.55776 630.682 365.533)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.159,
    cy: 366.455,
    r: 1.38857,
    transform: "rotate(9.55776 636.159 366.455)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1428 338.26L36.4827 348.119C36.2281 349.631 37.2477 351.064 38.7602 351.319L40.1295 351.549L39.9549 352.586C39.7647 353.715 39.5788 355.402 40.7128 355.56C41.4821 355.668 41.9135 354.778 42.4382 354.205L44.2374 352.241L54.0963 353.901C56.2138 354.257 58.2193 352.83 58.5758 350.713L60.0515 341.949C60.4081 339.831 58.9811 337.826 56.8636 337.469L42.6218 335.071C40.5043 334.715 38.4993 336.142 38.1428 338.26Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.8826,
    cy: 343.564,
    r: 1.38857,
    transform: "rotate(9.55776 42.8826 343.564)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3598,
    cy: 344.486,
    r: 1.38857,
    transform: "rotate(9.55776 48.3598 344.486)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.837,
    cy: 345.408,
    r: 1.38857,
    transform: "rotate(9.55776 53.837 345.408)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.396 347.615L514.736 357.474C514.481 358.986 515.501 360.419 517.013 360.674L518.383 360.904L518.208 361.941C518.018 363.07 517.832 364.757 518.966 364.915C519.735 365.023 520.167 364.133 520.691 363.56L522.49 361.596L532.349 363.256C534.467 363.612 536.472 362.185 536.829 360.068L538.305 351.304C538.661 349.186 537.234 347.181 535.117 346.824L520.875 344.426C518.757 344.07 516.752 345.497 516.396 347.615Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 521.135,
    cy: 352.919,
    r: 1.38857,
    transform: "rotate(9.55776 521.135 352.919)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.612,
    cy: 353.841,
    r: 1.38857,
    transform: "rotate(9.55776 526.612 353.841)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532.09,
    cy: 354.764,
    r: 1.38857,
    transform: "rotate(9.55776 532.09 354.764)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0213 469.224L56.3613 479.083C56.1066 480.595 57.1263 482.028 58.6387 482.283L60.008 482.513L59.8334 483.55C59.6433 484.679 59.4573 486.366 60.5913 486.524C61.3607 486.632 61.792 485.742 62.3167 485.169L64.1159 483.205L73.9748 484.865C76.0923 485.221 78.0979 483.794 78.4544 481.677L79.9301 472.913C80.2866 470.795 78.8596 468.79 76.7421 468.433L62.5003 466.035C60.3829 465.679 58.3778 467.106 58.0213 469.224Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.7608,
    cy: 474.528,
    r: 1.38857,
    transform: "rotate(9.55776 62.7608 474.528)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.2381,
    cy: 475.45,
    r: 1.38857,
    transform: "rotate(9.55776 68.2381 475.45)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.7153,
    cy: 476.372,
    r: 1.38857,
    transform: "rotate(9.55776 73.7153 476.372)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.275 469.223L534.615 479.082C534.36 480.594 535.38 482.027 536.892 482.281L538.262 482.512L538.087 483.549C537.897 484.678 537.711 486.365 538.845 486.523C539.614 486.631 540.046 485.741 540.57 485.168L542.37 483.204L552.229 484.864C554.346 485.22 556.352 483.793 556.708 481.675L558.184 472.911C558.54 470.794 557.113 468.789 554.996 468.432L540.754 466.034C538.637 465.678 536.632 467.105 536.275 469.223Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.015,
    cy: 474.526,
    r: 1.38857,
    transform: "rotate(9.55776 541.015 474.526)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.492,
    cy: 475.449,
    r: 1.38857,
    transform: "rotate(9.55776 546.492 475.449)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.969,
    cy: 476.371,
    r: 1.38857,
    transform: "rotate(9.55776 551.969 476.371)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.199 556.759L166.755 559.698C168.221 560.149 169.774 559.326 170.225 557.86L170.634 556.533L171.639 556.842C172.733 557.178 174.381 557.584 174.687 556.48C174.894 555.732 174.068 555.187 173.569 554.592L171.858 552.551L174.797 542.995C175.428 540.942 174.276 538.767 172.224 538.136L163.729 535.523C161.677 534.892 159.501 536.044 158.87 538.096L154.625 551.901C153.994 553.953 155.146 556.128 157.199 556.759Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.078,
    cy: 552.756,
    r: 1.38857,
    transform: "rotate(-72.9055 163.078 552.756)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.711,
    cy: 547.447,
    r: 1.38857,
    transform: "rotate(-72.9055 164.711 547.447)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.344,
    cy: 542.139,
    r: 1.38857,
    transform: "rotate(-72.9055 166.344 542.139)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.79 561.844L647.346 564.783C648.812 565.234 650.366 564.411 650.817 562.945L651.225 561.618L652.23 561.927C653.325 562.264 654.972 562.669 655.278 561.566C655.486 560.817 654.66 560.273 654.161 559.677L652.45 557.636L655.389 548.08C656.02 546.028 654.868 543.852 652.815 543.221L644.321 540.609C642.268 539.977 640.093 541.129 639.462 543.181L635.217 556.986C634.585 559.038 635.738 561.213 637.79 561.844Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.67,
    cy: 557.842,
    r: 1.38857,
    transform: "rotate(-72.9055 643.67 557.842)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.303,
    cy: 552.533,
    r: 1.38857,
    transform: "rotate(-72.9055 645.303 552.533)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.936,
    cy: 547.224,
    r: 1.38857,
    transform: "rotate(-72.9055 646.936 547.224)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.509 425.96L197.849 435.818C197.595 437.331 198.614 438.763 200.127 439.018L201.496 439.249L201.321 440.286C201.131 441.415 200.945 443.102 202.079 443.26C202.849 443.367 203.28 442.477 203.805 441.905L205.604 439.94L215.463 441.6C217.58 441.957 219.586 440.53 219.942 438.412L221.418 429.648C221.775 427.531 220.348 425.526 218.23 425.169L203.988 422.771C201.871 422.414 199.866 423.842 199.509 425.96Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.249,
    cy: 431.263,
    r: 1.38857,
    transform: "rotate(9.55776 204.249 431.263)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.726,
    cy: 432.186,
    r: 1.38857,
    transform: "rotate(9.55776 209.726 432.186)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.204,
    cy: 433.108,
    r: 1.38857,
    transform: "rotate(9.55776 215.204 433.108)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.763 425.958L676.102 435.816C675.848 437.329 676.867 438.762 678.38 439.016L679.749 439.247L679.575 440.284C679.384 441.413 679.199 443.1 680.333 443.258C681.102 443.365 681.533 442.475 682.058 441.903L683.857 439.938L693.716 441.598C695.834 441.955 697.839 440.528 698.196 438.41L699.671 429.646C700.028 427.529 698.601 425.524 696.483 425.167L682.242 422.769C680.124 422.412 678.119 423.84 677.763 425.958Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682.502,
    cy: 431.261,
    r: 1.38857,
    transform: "rotate(9.55776 682.502 431.261)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.979,
    cy: 432.184,
    r: 1.38857,
    transform: "rotate(9.55776 687.979 432.184)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 693.456,
    cy: 433.106,
    r: 1.38857,
    transform: "rotate(9.55776 693.456 433.106)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.201 555.331L396.225 564.86C396.689 566.322 398.25 567.131 399.712 566.667L401.036 566.247L401.354 567.25C401.7 568.341 402.305 569.926 403.386 569.55C404.12 569.294 404.097 568.305 404.302 567.556L405.006 564.987L414.536 561.963C416.583 561.314 417.715 559.128 417.066 557.082L414.378 548.61C413.728 546.564 411.543 545.431 409.496 546.081L395.731 550.449C393.684 551.098 392.552 553.284 393.201 555.331Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.145,
    cy: 557.885,
    r: 1.38857,
    transform: "rotate(-17.6057 388.145 557.885)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.439,
    cy: 556.206,
    r: 1.38857,
    transform: "rotate(-17.6057 393.439 556.206)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.734,
    cy: 554.526,
    r: 1.38857,
    transform: "rotate(-17.6057 398.734 554.526)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4987 569.857L34.1079 579.725C34.3547 581.238 35.782 582.266 37.2958 582.019L38.6662 581.795L38.8355 582.833C39.0198 583.963 39.3878 585.62 40.5124 585.404C41.2753 585.257 41.3964 584.276 41.7083 583.564L42.7776 581.125L52.645 579.516C54.7643 579.17 56.2022 577.172 55.8566 575.053L54.4261 566.281C54.0805 564.162 52.0829 562.724 49.9637 563.07L35.7097 565.394C33.5904 565.74 32.1531 567.738 32.4987 569.857Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.6958,
    cy: 573.349,
    r: 1.38857,
    transform: "rotate(-9.26213 38.6958 573.349)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.1776,
    cy: 572.455,
    r: 1.38857,
    transform: "rotate(-9.26213 44.1776 572.455)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.6593,
    cy: 571.561,
    r: 1.38857,
    transform: "rotate(-9.26213 49.6593 571.561)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.09 574.943L514.699 584.81C514.946 586.324 516.373 587.351 517.887 587.104L519.258 586.881L519.427 587.919C519.611 589.049 519.979 590.705 521.104 590.489C521.867 590.343 521.988 589.361 522.3 588.65L523.369 586.21L533.236 584.601C535.356 584.255 536.794 582.257 536.448 580.138L535.018 571.367C534.672 569.247 532.674 567.81 530.555 568.155L516.301 570.48C514.182 570.825 512.745 572.823 513.09 574.943Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.287,
    cy: 578.434,
    r: 1.38857,
    transform: "rotate(-9.26213 519.287 578.434)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.769,
    cy: 577.54,
    r: 1.38857,
    transform: "rotate(-9.26213 524.769 577.54)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.251,
    cy: 576.646,
    r: 1.38857,
    transform: "rotate(-9.26213 530.251 576.646)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.425 368.663L307.765 378.521C307.511 380.034 308.53 381.466 310.043 381.721L311.412 381.952L311.238 382.989C311.047 384.118 310.861 385.805 311.996 385.963C312.765 386.07 313.196 385.18 313.721 384.608L315.52 382.643L325.379 384.303C327.496 384.66 329.502 383.233 329.859 381.115L331.334 372.351C331.691 370.234 330.264 368.229 328.146 367.872L313.905 365.474C311.787 365.117 309.782 366.545 309.425 368.663Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.165,
    cy: 373.966,
    r: 1.38857,
    transform: "rotate(9.55776 314.165 373.966)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.642,
    cy: 374.889,
    r: 1.38857,
    transform: "rotate(9.55776 319.642 374.889)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.119,
    cy: 375.811,
    r: 1.38857,
    transform: "rotate(9.55776 325.119 375.811)",
    fill: "#FDDC9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3532 128.241L57.2708 128.982C58.7697 130.193 58.959 132.404 57.6878 133.852L57.5605 133.998C56.6495 135.036 56.4065 136.569 57.3164 137.607C58.1868 138.6 59.3549 139.473 61.0516 140.424C62.3896 141.174 64.0626 140.818 65.0739 139.666L65.1625 139.565C66.3681 138.191 68.4471 138.013 69.8687 139.161L70.7202 139.849C71.9415 140.836 72.3667 142.559 71.4887 143.86C70.6602 145.088 69.736 146.049 68.6451 146.834C67.9492 147.335 67.0527 147.447 66.2243 147.224C58.1253 145.049 53.2257 141.098 49.7108 133.779C49.4047 133.142 49.3045 132.409 49.5527 131.747C50.0769 130.348 51.0573 129.171 52.5726 128.043C53.703 127.203 55.2583 127.356 56.3532 128.241Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2128 129.425L57.8228 133.958",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1516 129.143L65.1388 132.135",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8051 133.458L67.5144 134.253",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0071 129.731L63.8217 127.455",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3031 140.001L70.9131 144.534",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.607 128.239L535.524 128.981C537.023 130.192 537.212 132.402 535.941 133.851L535.814 133.996C534.903 135.034 534.66 136.568 535.57 137.605C536.44 138.598 537.608 139.471 539.305 140.423C540.643 141.173 542.316 140.817 543.327 139.664L543.416 139.563C544.621 138.19 546.7 138.011 548.122 139.16L548.974 139.848C550.195 140.835 550.62 142.557 549.742 143.859C548.914 145.087 547.989 146.048 546.898 146.833C546.203 147.334 545.306 147.445 544.478 147.223C536.379 145.048 531.479 141.097 527.964 133.778C527.658 133.14 527.558 132.408 527.806 131.746C528.33 130.347 529.311 129.169 530.826 128.042C531.956 127.201 533.512 127.354 534.607 128.239Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.467 129.423L536.077 133.956",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.406 129.142L543.393 132.133",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.059 133.456L545.768 134.252",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.261 129.73L542.076 127.454",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.557 140L549.167 144.533",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5068 431.096L51.4243 431.837C52.9232 433.048 53.1125 435.259 51.8414 436.708L51.714 436.853C50.8031 437.891 50.56 439.424 51.47 440.462C52.3404 441.455 53.5084 442.328 55.2052 443.279C56.5432 444.03 58.2161 443.674 59.2274 442.521L59.3161 442.42C60.5216 441.046 62.6006 440.868 64.0222 442.016L64.8737 442.705C66.0951 443.691 66.5202 445.414 65.6423 446.715C64.8137 447.943 63.8895 448.904 62.7986 449.69C62.1028 450.191 61.2063 450.302 60.3779 450.079C52.2788 447.905 47.3793 443.953 43.8644 436.634C43.5583 435.997 43.4581 435.264 43.7063 434.602C44.2305 433.204 45.2108 432.026 46.7261 430.899C47.8566 430.058 49.4118 430.211 50.5068 431.096Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3662 432.28L51.9762 436.813",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3052 431.999L59.2924 434.99",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9585 436.313L61.6678 437.108",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1611 432.587L57.9757 430.31",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4567 442.856L65.0667 447.389",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.76 431.094L529.678 431.835C531.177 433.047 531.366 435.257 530.095 436.706L529.967 436.851C529.056 437.889 528.813 439.423 529.723 440.46C530.594 441.453 531.762 442.326 533.458 443.278C534.796 444.028 536.469 443.672 537.481 442.519L537.569 442.418C538.775 441.044 540.854 440.866 542.276 442.015L543.127 442.703C544.348 443.69 544.774 445.412 543.896 446.713C543.067 447.942 542.143 448.903 541.052 449.688C540.356 450.189 539.46 450.3 538.631 450.078C530.532 447.903 525.633 443.951 522.118 436.633C521.812 435.995 521.711 435.263 521.96 434.6C522.484 433.202 523.464 432.024 524.979 430.897C526.11 430.056 527.665 430.209 528.76 431.094Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.62 432.278L530.23 436.811",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.558 431.997L537.546 434.988",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.212 436.311L539.921 437.107",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.415 432.585L536.229 430.309",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.71 442.855L543.32 447.388",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.52 502.559L199.153 503.68C198.554 505.511 196.555 506.474 194.749 505.801L194.568 505.734C193.274 505.251 191.755 505.569 191.108 506.789C190.49 507.955 190.089 509.358 189.803 511.282C189.578 512.799 190.505 514.236 191.942 514.772L192.068 514.819C193.781 515.457 194.686 517.337 194.118 519.074L193.778 520.114C193.29 521.607 191.831 522.616 190.303 522.259C188.86 521.921 187.633 521.399 186.511 520.658C185.796 520.186 185.373 519.388 185.286 518.534C184.44 510.191 186.391 504.207 191.982 498.319C192.469 497.807 193.118 497.453 193.825 497.449C195.318 497.442 196.768 497.939 198.36 498.955C199.548 499.712 199.958 501.221 199.52 502.559Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.774 502.561L677.407 503.682C676.808 505.513 674.81 506.476 673.004 505.803L672.823 505.736C671.528 505.253 670.009 505.571 669.362 506.791C668.744 507.957 668.343 509.36 668.057 511.284C667.832 512.801 668.759 514.238 670.196 514.774L670.322 514.82C672.035 515.459 672.941 517.339 672.372 519.076L672.032 520.116C671.544 521.609 670.085 522.618 668.557 522.26C667.114 521.923 665.887 521.401 664.766 520.66C664.05 520.188 663.627 519.39 663.541 518.536C662.694 510.193 664.645 504.209 670.236 498.321C670.723 497.809 671.372 497.454 672.079 497.451C673.573 497.444 675.022 497.941 676.614 498.957C677.802 499.714 678.212 501.223 677.774 502.561Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.941 499.11L194.699 505.965",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.195 499.111L672.953 505.966",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.871 513.907L199.004 512.154",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.427 516.986L197.869 515.128",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.492 509.308L202.909 509.26",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.746 509.309L681.163 509.261",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.71 515.105L189.468 521.961",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.156 444.232L316.494 445.362C317.048 447.208 315.956 449.139 314.089 449.617L313.902 449.665C312.564 450.008 311.498 451.136 311.663 452.506C311.821 453.817 312.292 455.197 313.155 456.941C313.836 458.315 315.418 458.966 316.903 458.586L317.033 458.552C318.804 458.099 320.62 459.126 321.145 460.876L321.46 461.925C321.911 463.429 321.289 465.091 319.83 465.669C318.452 466.215 317.147 466.486 315.803 466.519C314.946 466.539 314.143 466.125 313.585 465.474C308.128 459.106 306.315 453.078 307.546 445.053C307.653 444.354 307.984 443.693 308.563 443.287C309.785 442.428 311.26 442.009 313.147 441.935C314.554 441.879 315.751 442.884 316.156 444.232Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.07 442.872L314.141 449.781",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.385 451.639L321.209 452.407",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.313 456.133L321.973 455.496",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.806 449.219L322.763 447.8",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.903 458.992L318.974 465.901",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.521 426.419L424.438 427.161C425.937 428.372 426.126 430.582 424.855 432.031L424.728 432.176C423.817 433.214 423.574 434.748 424.484 435.786C425.354 436.778 426.522 437.651 428.219 438.603C429.557 439.353 431.23 438.997 432.241 437.845L432.33 437.744C433.536 436.37 435.615 436.191 437.036 437.34L437.888 438.028C439.109 439.015 439.534 440.737 438.656 442.039C437.828 443.267 436.903 444.228 435.813 445.013C435.117 445.514 434.22 445.625 433.392 445.403C425.293 443.228 420.393 439.277 416.878 431.958C416.572 431.321 416.472 430.588 416.72 429.926C417.244 428.527 418.225 427.349 419.74 426.222C420.87 425.381 422.426 425.535 423.521 426.419Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.38 427.604L424.99 432.137",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.319 427.322L432.306 430.313",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.972 431.636L434.682 432.432",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.175 427.91L430.989 425.634",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.471 438.18L438.081 442.713",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.056 449.047L165.214 449.872C163.838 451.221 161.62 451.154 160.328 449.724L160.198 449.581C159.272 448.556 157.777 448.138 156.641 448.922C155.555 449.672 154.552 450.731 153.412 452.307C152.512 453.549 152.672 455.252 153.7 456.39L153.79 456.489C155.016 457.845 154.953 459.931 153.648 461.211L152.866 461.977C151.745 463.076 149.985 463.3 148.793 462.277C147.669 461.312 146.821 460.283 146.167 459.109C145.75 458.36 145.743 457.457 146.06 456.66C149.155 448.866 153.646 444.455 161.322 441.809C161.99 441.579 162.729 441.564 163.358 441.887C164.687 442.569 165.744 443.679 166.688 445.314C167.393 446.534 167.061 448.061 166.056 449.047Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.358 444.797L160.208 449.846",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.797 460.662L161.174 457.324",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.321 461.806L158.795 459.439",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.807 455.483L165.974 456.555",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.341 456.579L148.19 461.628",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.309 449.045L643.466 449.871C642.09 451.22 639.873 451.152 638.58 449.723L638.451 449.579C637.525 448.555 636.03 448.136 634.894 448.92C633.807 449.67 632.805 450.729 631.664 452.305C630.765 453.547 630.925 455.25 631.953 456.388L632.043 456.488C633.269 457.844 633.206 459.929 631.9 461.209L631.119 461.975C629.997 463.074 628.237 463.298 627.046 462.276C625.922 461.311 625.074 460.282 624.42 459.107C624.003 458.358 623.996 457.455 624.312 456.658C627.408 448.864 631.899 444.454 639.574 441.807C640.243 441.577 640.982 441.562 641.611 441.885C642.94 442.567 643.997 443.677 644.941 445.312C645.646 446.532 645.314 448.059 644.309 449.045Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.611 444.795L638.461 449.844",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.05 460.66L639.426 457.322",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.574 461.804L637.048 459.437",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.06 455.482L644.227 456.554",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.594 456.577L626.444 461.626",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3647 325.693L11.5323 326.861C11.8062 328.768 10.4404 330.517 8.52317 330.713L8.33108 330.732C6.95708 330.873 5.7354 331.831 5.69577 333.211C5.65787 334.53 5.91932 335.965 6.51497 337.817C6.98468 339.277 8.45264 340.155 9.97801 339.999L10.1117 339.985C11.93 339.799 13.5746 341.084 13.8343 342.893L13.9899 343.976C14.2131 345.531 13.3523 347.082 11.8234 347.438C10.3805 347.774 9.04938 347.849 7.71559 347.682C6.8648 347.575 6.13222 347.047 5.67668 346.32C1.22304 339.214 0.322681 332.984 2.72858 325.23C2.93807 324.555 3.36331 323.95 3.99581 323.634C5.33178 322.966 6.85171 322.77 8.72896 322.975C10.1294 323.129 11.1646 324.3 11.3647 325.693Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52466 323.743L8.54977 330.882",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 334.384L15.1512 334.526",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6687 338.67L15.4491 337.694",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2249 331.314L17.3709 330.201",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91772 340.401L10.9428 347.54",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.62 325.692L489.787 326.859C490.061 328.767 488.695 330.515 486.778 330.711L486.586 330.731C485.212 330.872 483.99 331.83 483.951 333.209C483.913 334.529 484.174 335.964 484.77 337.816C485.24 339.276 486.708 340.154 488.233 339.998L488.367 339.984C490.185 339.798 491.83 341.082 492.089 342.891L492.245 343.975C492.468 345.529 491.607 347.081 490.078 347.436C488.635 347.772 487.304 347.847 485.971 347.68C485.12 347.574 484.387 347.045 483.932 346.318C479.478 339.213 478.578 332.983 480.984 325.229C481.193 324.553 481.618 323.948 482.251 323.632C483.587 322.964 485.107 322.768 486.984 322.974C488.384 323.127 489.42 324.298 489.62 325.692Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.78 323.741L486.805 330.88",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.65 334.383L493.406 334.524",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.924 338.669L493.704 337.693",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.48 331.312L495.626 330.199",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.173 340.399L489.198 347.539",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46 158.644L251.378 159.385C252.877 160.596 253.066 162.807 251.795 164.256L251.668 164.401C250.757 165.439 250.514 166.972 251.424 168.01C252.294 169.003 253.462 169.876 255.159 170.827C256.497 171.578 258.17 171.222 259.181 170.069L259.27 169.968C260.475 168.594 262.554 168.416 263.976 169.565L264.827 170.253C266.049 171.239 266.474 172.962 265.596 174.263C264.767 175.491 263.843 176.452 262.752 177.238C262.056 177.739 261.16 177.85 260.332 177.628C252.232 175.453 247.333 171.501 243.818 164.182C243.512 163.545 243.412 162.812 243.66 162.15C244.184 160.752 245.164 159.574 246.68 158.447C247.81 157.606 249.365 157.759 250.46 158.644Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.32 159.828L251.93 164.361",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.259 159.547L259.246 162.538",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.913 163.861L261.622 164.656",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.115 160.134L257.929 157.858",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41 170.404L265.02 174.937",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.714 158.642L729.631 159.384C731.13 160.595 731.32 162.805 730.048 164.254L729.921 164.399C729.01 165.437 728.767 166.971 729.677 168.009C730.547 169.001 731.715 169.874 733.412 170.826C734.75 171.576 736.423 171.22 737.434 170.068L737.523 169.967C738.729 168.593 740.808 168.414 742.229 169.563L743.081 170.251C744.302 171.238 744.727 172.96 743.849 174.262C743.021 175.49 742.097 176.451 741.006 177.236C740.31 177.737 739.413 177.848 738.585 177.626C730.486 175.451 725.586 171.5 722.071 164.181C721.765 163.544 721.665 162.811 721.913 162.149C722.438 160.75 723.418 159.572 724.933 158.445C726.064 157.604 727.619 157.758 728.714 158.642Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.573 159.826L730.183 164.359",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.512 159.545L737.499 162.536",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.166 163.859L739.875 164.655",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.368 160.133L736.182 157.857",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.664 170.403L743.274 174.936",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.917 210.094L378.835 210.835C380.333 212.047 380.523 214.257 379.252 215.706L379.124 215.851C378.213 216.889 377.97 218.422 378.88 219.46C379.751 220.453 380.919 221.326 382.615 222.277C383.953 223.028 385.626 222.672 386.638 221.519L386.726 221.418C387.932 220.044 390.011 219.866 391.432 221.015L392.284 221.703C393.505 222.69 393.93 224.412 393.052 225.713C392.224 226.941 391.3 227.902 390.209 228.688C389.513 229.189 388.616 229.3 387.788 229.078C379.689 226.903 374.789 222.951 371.275 215.632C370.968 214.995 370.868 214.262 371.116 213.6C371.641 212.202 372.621 211.024 374.136 209.897C375.267 209.056 376.822 209.209 377.917 210.094Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.776 211.278L379.386 215.811",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.715 210.997L386.703 213.988",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.369 215.311L389.078 216.106",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.571 211.585L385.385 209.308",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.867 221.854L392.477 226.387",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.048 86.1452L289.966 86.8866C291.465 88.0978 291.654 90.3083 290.383 91.757L290.255 91.9021C289.344 92.9403 289.101 94.4737 290.011 95.5115C290.882 96.5041 292.05 97.3774 293.746 98.3288C295.084 99.079 296.757 98.723 297.769 97.5705L297.857 97.4695C299.063 96.0955 301.142 95.9173 302.563 97.0659L303.415 97.754C304.636 98.7408 305.061 100.463 304.184 101.765C303.355 102.993 302.431 103.954 301.34 104.739C300.644 105.24 299.748 105.351 298.919 105.129C290.82 102.954 285.921 99.0026 282.406 91.6837C282.1 91.0465 281.999 90.3138 282.248 89.6516C282.772 88.2529 283.752 87.0751 285.267 85.948C286.398 85.1073 287.953 85.2605 289.048 86.1452Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.908 87.3295L290.518 91.8625",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.847 87.0479L297.834 90.0392",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5 91.3624L300.21 92.1578",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.702 87.636L296.517 85.3597",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.998 97.9058L303.608 102.439",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.816 29.1518L160.798 28.4981C162.403 27.4303 164.568 27.9112 165.57 29.5575L165.671 29.7225C166.389 30.9024 167.779 31.5931 169.042 31.0354C170.249 30.5019 171.432 29.6487 172.848 28.3144C173.964 27.2621 174.125 25.5593 173.328 24.2495L173.258 24.1347C172.308 22.5732 172.76 20.5362 174.281 19.5234L175.192 18.9168C176.499 18.0467 178.27 18.1565 179.249 19.3836C180.173 20.5417 180.813 21.711 181.236 22.987C181.506 23.8009 181.344 24.6896 180.884 25.4134C176.385 32.4906 171.149 35.9833 163.114 37.1472C162.414 37.2485 161.685 37.1249 161.127 36.6899C159.95 35.7712 159.119 34.4833 158.497 32.7002C158.033 31.37 158.645 29.9318 159.816 29.1518Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.707 33.4564L165.711 29.4598",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.208 18.1637L166.161 21.9336",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.819 17.8773L168.893 20.3011",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.23 23.2484L161.302 21.79",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.717 24.1306L179.721 20.134",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.223 23.3063L633.205 22.6527C634.809 21.5849 636.975 22.0657 637.977 23.7121L638.077 23.877C638.795 25.0569 640.185 25.7477 641.448 25.1899C642.656 24.6565 643.838 23.8032 645.254 22.4689C646.37 21.4167 646.531 19.7139 645.734 18.404L645.664 18.2893C644.714 16.7278 645.166 14.6907 646.687 13.678L647.599 13.0713C648.906 12.2013 650.676 12.311 651.655 13.5381C652.579 14.6962 653.22 15.8656 653.643 17.1415C653.912 17.9554 653.75 18.8441 653.29 19.568C648.792 26.6452 643.555 30.1378 635.52 31.3017C634.82 31.403 634.091 31.2794 633.533 30.8445C632.356 29.9258 631.525 28.6379 630.903 26.8548C630.439 25.5246 631.051 24.0864 632.223 23.3063Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.114 27.611L638.117 23.6144",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.614 12.3182L638.567 16.0881",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.226 12.0319L641.299 14.4556",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.637 17.4032L633.708 15.9448",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.123 18.2852L652.127 14.2886",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.507 -8.4442L601.686 -8.41372C603.613 -8.36395 605.107 -6.72436 604.979 -4.80133L604.967 -4.60865C604.875 -3.23052 605.615 -1.86552 606.968 -1.59514C608.263 -1.33654 609.721 -1.35375 611.646 -1.6305C613.165 -1.84875 614.276 -3.14876 614.378 -4.67872L614.387 -4.81278C614.508 -6.63662 616.05 -8.04256 617.877 -7.99535L618.972 -7.96707C620.541 -7.92651 621.926 -6.81779 622.021 -5.25087C622.11 -3.77206 621.961 -2.44722 621.573 -1.16031C621.325 -0.33943 620.681 0.294167 619.888 0.621409C612.137 3.82075 605.844 3.66395 598.603 -0.0079446C597.972 -0.327669 597.447 -0.848327 597.241 -1.52489C596.807 -2.95394 596.869 -4.48518 597.386 -6.30139C597.772 -7.65628 599.1 -8.48056 600.507 -8.4442Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81504 240.047L7.68793 239.254C9.11385 237.957 11.3273 238.108 12.5648 239.586L12.6888 239.734C13.5756 240.793 15.0538 241.267 16.2185 240.526C17.3325 239.818 18.3739 238.797 19.5733 237.265C20.5192 236.058 20.423 234.35 19.4385 233.174L19.3522 233.071C18.1786 231.67 18.32 229.588 19.6724 228.359L20.4825 227.622C21.6443 226.566 23.4115 226.409 24.5634 227.476C25.6506 228.482 26.459 229.542 27.0685 230.74C27.4573 231.505 27.4303 232.408 27.0839 233.192C23.6972 240.864 19.0436 245.102 11.2737 247.458C10.5971 247.663 9.85772 247.65 9.24124 247.304C7.93911 246.572 6.92482 245.423 6.04255 243.753C5.38438 242.508 5.7734 240.994 6.81504 240.047Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35278 244.32L12.6896 239.468",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51001 228.525L12.006 231.959",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0261 227.55L14.4622 229.936",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30542 233.699L7.18036 232.546",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8052 232.999L25.142 228.147",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.776 219.086L472.954 219.15C474.878 219.253 476.327 220.933 476.146 222.852L476.128 223.044C475.998 224.419 476.699 225.804 478.045 226.112C479.332 226.406 480.79 226.43 482.722 226.206C484.246 226.03 485.393 224.762 485.537 223.235L485.55 223.101C485.722 221.282 487.302 219.919 489.127 220.017L490.22 220.075C491.788 220.16 493.142 221.306 493.193 222.875C493.241 224.356 493.056 225.676 492.632 226.952C492.361 227.765 491.7 228.381 490.898 228.686C483.061 231.669 476.775 231.338 469.639 227.467C469.017 227.129 468.507 226.594 468.32 225.912C467.925 224.472 468.029 222.943 468.597 221.142C469.02 219.798 470.37 219.011 471.776 219.086Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.115 222.472L476.317 222.858",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.867 212.904L481.178 217.094",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.734 215.432L484.343 217.419",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.042 216.395L477.368 214.074",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.92 223.372L493.122 223.759",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.695 205.736L178.968 206.665C177.78 208.182 175.572 208.405 174.104 207.156L173.957 207.031C172.905 206.136 171.369 205.916 170.345 206.842C169.365 207.727 168.51 208.909 167.585 210.62C166.855 211.969 167.236 213.636 168.404 214.63L168.506 214.717C169.899 215.902 170.108 217.978 168.982 219.416L168.307 220.278C167.338 221.515 165.623 221.966 164.308 221.108C163.067 220.298 162.093 219.389 161.291 218.31C160.779 217.622 160.654 216.727 160.864 215.895C162.915 207.764 166.792 202.805 174.056 199.179C174.689 198.863 175.42 198.752 176.086 198.99C177.492 199.493 178.685 200.455 179.835 201.953C180.693 203.071 180.563 204.628 179.695 205.736Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.448 201.614L174.001 207.293",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.972 217.547L175.935 214.58",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.683 219.266L173.853 216.987",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.305 212.412L180.594 213.192",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.072 214.865L163.625 220.543",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.948 205.734L657.221 206.663C656.032 208.18 653.825 208.403 652.357 207.154L652.21 207.029C651.158 206.134 649.621 205.914 648.597 206.84C647.618 207.725 646.763 208.907 645.837 210.618C645.108 211.967 645.489 213.634 646.657 214.628L646.759 214.715C648.151 215.9 648.361 217.976 647.234 219.415L646.559 220.276C645.591 221.513 643.875 221.964 642.561 221.106C641.32 220.296 640.345 219.387 639.544 218.308C639.032 217.62 638.907 216.725 639.117 215.893C641.168 207.762 645.045 202.803 652.309 199.177C652.942 198.861 653.673 198.75 654.338 198.988C655.745 199.491 656.938 200.453 658.088 201.951C658.945 203.069 658.816 204.626 657.948 205.734Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.701 201.613L652.254 207.291",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.225 217.545L654.188 214.578",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.936 219.264L652.106 216.986",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.558 212.41L658.847 213.19",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.325 214.863L641.878 220.541",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.716 113.424V120.106",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.697 137.48L182.713 133.235",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.707 135.615L179.699 133.429",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.739 133.415L186.725 135.596",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.331 122.846C191.057 124.573 192.039 126.904 192.07 129.342C192.071 129.41 192.019 129.467 191.951 129.475C184.669 130.314 180.581 130.325 173.479 129.476C173.412 129.468 173.36 129.41 173.361 129.343C173.392 126.904 174.374 124.573 176.1 122.846C177.855 121.092 180.234 120.106 182.716 120.106C185.197 120.106 187.576 121.092 189.331 122.846Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.043 119.438V117.433H185.389V120.106",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.969 113.422V120.105",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.949 137.479L660.966 133.234",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.959 135.614L657.951 133.428",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.992 133.413L664.978 135.595",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.584 122.845C669.31 124.571 670.292 126.903 670.323 129.341C670.324 129.409 670.271 129.466 670.204 129.474C662.922 130.313 658.834 130.324 651.732 129.474C651.665 129.466 651.613 129.409 651.614 129.342C651.645 126.903 652.627 124.571 654.353 122.845C656.108 121.091 658.487 120.105 660.968 120.105C663.45 120.105 665.829 121.091 667.584 122.845Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.296 119.437V117.432H663.642V120.105",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.3 162.743L451.141 166.99",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.715 178.017L441.003 175.331",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.618 173.75L438.937 173.127",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.787 177.782L441.729 179.929",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.229 173.838C452.994 176.268 451.817 178.508 449.955 180.082C449.903 180.125 449.825 180.121 449.777 180.074C444.501 174.985 441.894 171.836 438.037 165.813C438 165.756 438.011 165.679 438.064 165.637C439.966 164.111 442.391 163.388 444.821 163.623C447.291 163.863 449.564 165.074 451.141 166.989C452.718 168.905 453.469 171.369 453.229 173.838Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.958 164.501L451.506 163.227L454.903 167.354L452.84 169.053",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4602 254.345L50.1948 260.906",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.886 277.962L47.7059 273.797",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3209 275.375L44.7094 273.417",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6429 274.547L51.1979 276.875",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1712 264.849C57.5394 266.871 58.0621 269.347 57.6309 271.747C57.6188 271.813 57.5566 271.86 57.4889 271.855C50.1796 271.299 46.1634 270.536 39.351 268.357C39.2866 268.337 39.2465 268.271 39.2601 268.204C39.7521 265.816 41.1579 263.712 43.1801 262.344C45.235 260.953 47.7582 260.436 50.1945 260.906C52.6308 261.376 54.7807 262.794 56.1712 264.849Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6964 259.744L48.076 257.775L53.3252 258.787L52.8191 261.412",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.714 254.343L528.449 260.904",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.14 277.961L525.96 273.795",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.575 275.374L522.963 273.415",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.897 274.545L529.452 276.874",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.425 264.848C535.793 266.87 536.316 269.345 535.885 271.745C535.873 271.812 535.811 271.858 535.743 271.853C528.433 271.298 524.417 270.534 517.605 268.356C517.541 268.335 517.5 268.269 517.514 268.203C518.006 265.814 519.412 263.711 521.434 262.342C523.489 260.952 526.012 260.435 528.448 260.904C530.885 261.374 533.035 262.793 534.425 264.848Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.95 259.742L526.33 257.774L531.579 258.786L531.073 261.411",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.513 54.1272L320.6 60.53",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.609 77.1716L316.84 73.1087",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.319 74.2423L313.896 72.4318",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.688 74.1472L320.008 76.5195",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.154 65.0489C327.314 67.1972 327.588 69.7124 326.92 72.0573C326.901 72.1226 326.835 72.1625 326.768 72.1507C319.55 70.8701 315.63 69.7105 309.068 66.8637C309.006 66.8368 308.973 66.7671 308.993 66.7025C309.721 64.3751 311.329 62.4219 313.478 61.2619C315.661 60.083 318.223 59.8197 320.6 60.5299C322.978 61.2402 324.975 62.8657 326.154 65.0489Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23 59.1244L318.804 57.2036L323.926 58.7338L323.161 61.2949",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6583 550.335L97.8675 556.642",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.902 573.045L90.514 569.033",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.519 572.604L87.7331 570.213",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4292 568.203L95.0807 569.935",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3248 557.041C95.5248 558.1 97.2224 559.976 98.0577 562.266C98.0809 562.33 98.0505 562.402 97.9894 562.431C91.394 565.63 87.5395 566.992 80.5562 568.538C80.4902 568.553 80.4222 568.516 80.4007 568.452C79.6237 566.141 79.7796 563.615 80.8383 561.415C81.9141 559.179 83.834 557.462 86.1757 556.642C88.5173 555.822 91.0889 555.965 93.3248 557.041Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4323 556.895L82.7695 555.003L87.8148 553.236L88.6985 555.758",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.862 530.873L607.179 530.873",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.493 578.131L571.105 574.119",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.11 577.69L568.324 575.299",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.021 573.289L575.672 575.021",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.916 562.127C576.116 563.185 577.814 565.061 578.649 567.352C578.672 567.416 578.642 567.487 578.581 567.517C571.985 570.716 568.131 572.078 561.147 573.624C561.081 573.639 561.014 573.602 560.992 573.538C560.215 571.226 560.371 568.701 561.43 566.501C562.505 564.265 564.425 562.548 566.767 561.728C569.109 560.907 571.68 561.051 573.916 562.127Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.024 561.981L563.361 560.089L568.406 558.322L569.29 560.844",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.682 579.154L321.77 585.556",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.323 590.075C328.483 592.223 328.757 594.738 328.089 597.083C328.07 597.149 328.004 597.189 327.937 597.177C320.719 595.896 316.799 594.737 310.238 591.89C310.175 591.863 310.142 591.793 310.162 591.729C310.89 589.401 312.498 587.448 314.647 586.288C316.83 585.109 319.392 584.846 321.769 585.556C324.147 586.266 326.145 587.892 327.323 590.075Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.399 584.151L319.973 582.23L325.095 583.76L324.33 586.321",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.873 587.339L405.961 593.742",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3043 103.82C38.371 100.368 37.323 96.827 34.9404 94.7693",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2707 107.747L18.6365 108.696C17.0744 109.104 15.4774 108.168 15.0694 106.606L14.1829 103.212C13.7749 101.65 14.7105 100.053 16.2726 99.6449L19.9068 98.6957C20.8316 98.4542 21.6047 97.8206 22.0231 96.9613L24.3815 92.1183C24.9661 90.9177 26.7287 91.0925 27.0662 92.3845L31.6018 109.751C31.9393 111.043 30.4872 112.057 29.3902 111.296L24.9648 108.225C24.1796 107.68 23.1955 107.505 22.2707 107.747Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9863 100.063L19.0547 107.982",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6148 103.575C34.4824 100.933 33.8812 98.2231 31.8419 96.7872",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.711 109.668C510.777 106.216 509.729 102.675 507.347 100.617",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.678 113.594L491.043 114.544C489.481 114.951 487.884 114.016 487.476 112.454L486.59 109.06C486.182 107.498 487.117 105.901 488.68 105.493L492.314 104.543C493.238 104.302 494.012 103.668 494.43 102.809L496.788 97.9659C497.373 96.7654 499.136 96.9402 499.473 98.2322L504.009 115.599C504.346 116.891 502.894 117.905 501.797 117.144L497.372 114.072C496.586 113.527 495.602 113.353 494.678 113.594Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.393 105.911L491.461 113.83",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.021 109.423C506.889 106.781 506.288 104.071 504.248 102.635",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.577 19.6292C378.644 16.1765 377.596 12.6358 375.214 10.5782",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.544 23.5555L358.91 24.5047C357.347 24.9127 355.75 23.9771 355.342 22.415L354.456 19.0209C354.048 17.4588 354.984 15.8617 356.546 15.4537L360.18 14.5046C361.105 14.263 361.878 13.6295 362.296 12.7701L364.655 7.9271C365.239 6.72658 367.002 6.90138 367.339 8.19334L371.875 25.5599C372.212 26.8519 370.76 27.8663 369.663 27.1049L365.238 24.0336C364.453 23.4887 363.469 23.314 362.544 23.5555Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.259 15.8716L359.328 23.7912",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.888 19.3842C374.755 16.7419 374.154 14.0319 372.115 12.596",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.943 101.435C357.97 99.461 359.427 96.0681 358.91 92.9628",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.871 94.845L337.47 93.2521C336.008 92.5674 335.377 90.8271 336.062 89.365L337.55 86.1881C338.234 84.726 339.975 84.0957 341.437 84.7804L344.839 86.3733C345.704 86.7787 346.704 86.7856 347.575 86.3921L352.484 84.1749C353.701 83.6253 354.945 84.8864 354.378 86.0957L346.766 102.351C346.2 103.56 344.435 103.412 344.078 102.125L342.638 96.9347C342.382 96.0137 341.737 95.2504 340.871 94.845Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.719 85.558L338.248 92.9707",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.262 98.8878C354.618 97.4102 355.888 94.9418 355.237 92.534",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.124 175.039C220.837 173.27 222.142 170.231 221.679 167.448",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.517 169.135L202.469 167.708C201.159 167.094 200.595 165.535 201.208 164.225L202.541 161.378C203.154 160.068 204.714 159.504 206.024 160.117L209.071 161.544C209.847 161.908 210.742 161.914 211.523 161.561L215.921 159.575C217.012 159.082 218.126 160.212 217.619 161.296L210.799 175.86C210.291 176.943 208.71 176.81 208.39 175.658L207.1 171.007C206.871 170.182 206.292 169.498 205.517 169.135Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.276 160.814L203.166 167.455",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.722 172.757C217.833 171.433 218.971 169.221 218.388 167.064",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.377 175.037C699.089 173.269 700.395 170.229 699.931 167.447",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.77 169.133L680.722 167.706C679.412 167.092 678.847 165.533 679.461 164.223L680.794 161.377C681.407 160.067 682.966 159.502 684.276 160.115L687.324 161.542C688.099 161.906 688.995 161.912 689.775 161.559L694.174 159.573C695.264 159.08 696.379 160.21 695.871 161.294L689.051 175.858C688.544 176.941 686.962 176.808 686.643 175.656L685.352 171.005C685.123 170.18 684.545 169.496 683.77 169.133Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.529 160.812L681.419 167.454",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.975 172.755C696.086 171.431 697.224 169.22 696.641 167.062",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.238 27.7043C490.95 25.9361 492.255 22.8962 491.792 20.114",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63 21.8004L472.583 20.3732C471.273 19.7598 470.708 18.2005 471.322 16.8905L472.655 14.0441C473.268 12.7341 474.827 12.1694 476.137 12.7829L479.185 14.2101C479.96 14.5733 480.856 14.5794 481.636 14.2269L486.035 12.2404C487.125 11.748 488.24 12.8779 487.732 13.9613L480.912 28.5252C480.405 29.6087 478.823 29.4761 478.504 28.3233L477.213 23.6727C476.984 22.8475 476.406 22.1636 475.63 21.8004Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.39 13.4796L473.28 20.1211",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.836 25.4226C487.947 24.0988 489.084 21.8872 488.502 19.7299",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.457 309.51C147.169 307.742 148.475 304.702 148.011 301.92",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.849 303.607L128.802 302.179C127.492 301.566 126.927 300.007 127.54 298.697L128.873 295.85C129.487 294.54 131.046 293.976 132.356 294.589L135.404 296.016C136.179 296.38 137.075 296.386 137.855 296.033L142.254 294.047C143.344 293.554 144.458 294.684 143.951 295.768L137.131 310.332C136.624 311.415 135.042 311.282 134.722 310.13L133.432 305.479C133.203 304.654 132.625 303.97 131.849 303.607Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.609 295.286L129.499 301.927",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.055 307.229C144.166 305.905 145.304 303.693 144.721 301.536",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.71 309.509C625.423 307.741 626.728 304.701 626.265 301.919",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.102 303.605L607.055 302.178C605.745 301.565 605.18 300.005 605.794 298.695L607.126 295.849C607.74 294.539 609.299 293.974 610.609 294.588L613.657 296.015C614.432 296.378 615.328 296.384 616.108 296.032L620.507 294.045C621.597 293.553 622.712 294.683 622.204 295.766L615.384 310.33C614.877 311.413 613.295 311.281 612.975 310.128L611.685 305.477C611.456 304.652 610.878 303.968 610.102 303.605Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.862 295.285L607.752 301.926",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.308 307.227C622.419 305.904 623.556 303.692 622.974 301.535",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.063 199.594C413.775 197.826 415.081 194.786 414.617 192.004",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.455 193.691L395.407 192.263C394.097 191.65 393.533 190.091 394.146 188.781L395.479 185.934C396.093 184.624 397.652 184.06 398.962 184.673L402.01 186.1C402.785 186.463 403.681 186.47 404.461 186.117L408.86 184.131C409.95 183.638 411.064 184.768 410.557 185.851L403.737 200.415C403.229 201.499 401.648 201.366 401.328 200.213L400.038 195.563C399.809 194.738 399.231 194.054 398.455 193.691Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.215 185.37L396.104 192.011",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.661 197.313C410.772 195.989 411.909 193.777 411.326 191.62",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.837 297.784C438.874 296.478 435.615 297.045 433.537 298.952",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.778 311.569L444.247 314.901C444.449 316.333 443.451 317.658 442.019 317.86L438.906 318.298C437.474 318.5 436.149 317.502 435.948 316.07L435.478 312.737C435.359 311.889 434.875 311.136 434.153 310.675L430.087 308.075C429.079 307.431 429.417 305.88 430.601 305.713L446.526 303.471C447.711 303.304 448.463 304.701 447.672 305.599L444.482 309.22C443.916 309.863 443.658 310.721 443.778 311.569Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.394 315.478L443.656 314.455",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.237 301.042C438.975 299.997 436.501 300.252 435.013 301.919",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.653 244.188C240.336 240.966 238.242 238.405 235.56 237.532",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.596 252.647L226.923 254.692C225.774 255.571 224.13 255.352 223.251 254.203L221.342 251.707C220.463 250.558 220.681 248.915 221.83 248.036L224.503 245.991C225.183 245.47 225.602 244.679 225.649 243.824L225.917 239.005C225.984 237.81 227.501 237.343 228.228 238.293L237.999 251.066C238.726 252.016 237.879 253.358 236.708 253.109L231.987 252.107C231.15 251.93 230.276 252.127 229.596 252.647Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.565 248.133L227.021 253.958",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.519 245.266C237.319 242.782 235.883 240.752 233.7 240.273",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.905 244.187C718.588 240.965 716.494 238.404 713.812 237.53",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.848 252.646L705.176 254.691C704.027 255.57 702.383 255.351 701.504 254.202L699.594 251.706C698.715 250.557 698.934 248.913 700.083 248.034L702.755 245.989C703.436 245.469 703.854 244.677 703.902 243.822L704.17 239.003C704.236 237.809 705.753 237.342 706.48 238.292L716.252 251.064C716.979 252.014 716.131 253.356 714.961 253.108L710.24 252.106C709.402 251.928 708.528 252.126 707.848 252.646Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.818 248.132L705.274 253.956",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.772 245.264C715.572 242.781 714.135 240.751 711.953 240.272",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.85 483.9C400.533 480.678 398.439 478.116 395.757 477.243",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.793 492.359L387.12 494.404C385.971 495.283 384.327 495.064 383.448 493.915L381.539 491.419C380.66 490.27 380.878 488.626 382.027 487.747L384.7 485.702C385.38 485.182 385.799 484.39 385.846 483.535L386.114 478.716C386.181 477.522 387.697 477.055 388.424 478.005L398.196 490.777C398.923 491.727 398.076 493.069 396.905 492.821L392.184 491.819C391.346 491.641 390.473 491.838 389.793 492.359Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.762 487.844L387.218 493.669",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.716 484.977C397.516 482.494 396.08 480.464 393.897 479.985",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6505 289.792C19.3338 286.57 17.2397 284.008 14.5577 283.135",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59392 298.251L5.92116 300.296C4.7723 301.175 3.12843 300.956 2.24946 299.807L0.339648 297.311C-0.53932 296.162 -0.320537 294.518 0.828315 293.639L3.50108 291.594C4.18121 291.074 4.6 290.282 4.64754 289.427L4.91546 284.608C4.98187 283.414 6.49859 282.947 7.22555 283.897L16.9974 296.669C17.7244 297.619 16.8768 298.961 15.7065 298.713L10.9853 297.711C10.1476 297.533 9.27405 297.73 8.59392 298.251Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 293.737L6.01874 299.561",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5173 290.87C16.3172 288.386 14.8804 286.356 12.6977 285.877",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.396 296.809C494.079 293.586 491.985 291.025 489.303 290.152",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.339 305.267L480.666 307.312C479.517 308.191 477.873 307.972 476.994 306.824L475.084 304.327C474.205 303.179 474.424 301.535 475.573 300.656L478.246 298.611C478.926 298.09 479.345 297.299 479.392 296.444L479.66 291.625C479.727 290.43 481.243 289.963 481.97 290.913L491.742 303.686C492.469 304.636 491.622 305.978 490.451 305.729L485.73 304.728C484.892 304.55 484.019 304.747 483.339 305.267Z",
    fill: "#FFF8DE",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.307 300.753L480.764 306.578",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.263 297.886C491.063 295.402 489.626 293.372 487.443 292.894",
    stroke: "#FDDC9F",
    strokeWidth: 1.75398,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_19003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 752,
    height: 587,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBackground);
export default __webpack_public_path__ + "static/media/defaultBackground.c0e4c6d6dbda87e9e79caf7c7ca50208.svg";
export { ForwardRef as ReactComponent };